/* =========== mai2.js  ·  MAI capa 2 : header =========== */
(function(){
  var Q=String.fromCharCode(63), A=String.fromCharCode(38);
  var CACHE={};
  var BAN=[];

  function money(c){ var s=String(Math.round(c/100)), o='', k=0;
    for(var i=s.length-1;i>=0;i--){ o=s.charAt(i)+o; k++; if(k%3===0&&i>0){ o='.'+o; } }
    return '$'+o; }
  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function thumb(u,w){ if(!u){ return ''; } return String(u).split(Q)[0]+Q+'width='+w; }
  function banned(u){ u=String(u).toLowerCase(); for(var i=0;i<BAN.length;i++){ if(u.indexOf(BAN[i])>=0){ return true; } } return false; }
  function getProd(h){ if(CACHE[h]){ return Promise.resolve(CACHE[h]); }
    return fetch('/products/'+h+'.js').then(function(r){ return r.json(); }).then(function(j){ CACHE[h]=j; return j; }).catch(function(){ return null; }); }
  function headerEl(){ return document.getElementById('header-component'); }
  function topPx(){ var h=headerEl(); if(!h){ return 66; } return Math.max(0,Math.round(h.getBoundingClientRect().bottom)); }
  function killDialogs(){ [].forEach.call(document.querySelectorAll('dialog.search-modal__content'),function(d){ try{ if(d.open){ d.close(); } }catch(e){} }); }

  var ICO_SEARCH='<svg class="maiS__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><circle cx="11" cy="11" r="7"></circle><line x1="16.2" y1="16.2" x2="21" y2="21"></line></svg>';
  var ICO_X='<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="12" cy="12" r="9"></circle><line x1="9.2" y1="9.2" x2="14.8" y2="14.8"></line><line x1="14.8" y1="9.2" x2="9.2" y2="14.8"></line></svg>';

  var CHIPS=[['Bikinis','/collections/all'],['Tops','/collections/tops'],['Bottoms','/collections/bottoms'],['The Essentials','/collections/the-essentials'],['Nuevos','/collections/all'+Q+'sort_by=created-descending']];
  var SUGG=['top-pipa','bottom-pipa','top-saona','bottom-saona'];
  var MCOLS=[['Trajes de baño',[['Conjuntos','/collections/the-essentials'],['All','/collections/all'],['Tops','/collections/tops'],['Bottoms','/collections/bottoms']]],['Colecciones',[['The Essentials','/collections/the-essentials']]]];
  var MCARDS=[['Nuevos','/collections/all'+Q+'sort_by=created-descending','top-saona'],['The Essentials','/collections/the-essentials','top-pipa'],['Best Sellers','/collections/all'+Q+'sort_by=best-selling','bottom-pipa']];

  var ovS=null, ovM=null, inputEl=null, gridEl=null, tienda=null, tmr=null, mtmr=null, bt=null;

  function mkOv(id,cls,inner){
    var d=document.createElement('div');
    d.id=id; d.className='maiOv '+cls;
    d.innerHTML='<div class="maiOv__dim"></div><div class="maiOv__panel">'+inner+'</div>';
    document.body.appendChild(d);
    d.querySelector('.maiOv__dim').addEventListener('click',function(){ closeAll(); });
    return d;
  }
  function place(d){ var p=d.querySelector('.maiOv__panel'); p.style.top=topPx()+'px'; }
  function closeAll(){ if(ovS){ ovS.classList.remove('on'); } closeMega(); }

  function cardHTML(p){
    if(!p){ return ''; }
    var im=p.featured_image||(p.images&&p.images[0])||'';
    var pr=(p.price!==undefined&&p.price!==null)?p.price:((p.variants&&p.variants[0])?p.variants[0].price:0);
    return '<a class="maiS__card" href="/products/'+p.handle+'"><img src="'+thumb(im,700)+'" alt="'+esc(p.title)+'" loading="lazy"><div class="maiS__nm">'+esc(p.title)+'</div><div class="maiS__pr">'+money(pr)+'</div></a>';
  }
  function fillDefault(){
    Promise.all(SUGG.map(getProd)).then(function(list){
      if(gridEl){ gridEl.innerHTML=list.filter(Boolean).map(cardHTML).join(''); }
    });
  }
  function search(v){
    var url='/search/suggest.json'+Q+'q='+encodeURIComponent(v)+A+'resources[type]=product'+A+'resources[limit]=6';
    fetch(url).then(function(r){ return r.json(); }).then(function(j){
      var ps=(j.resources&&j.resources.results&&j.resources.results.products)||[];
      ps=ps.filter(function(p){ return !banned(p.handle||p.url||p.title); }).slice(0,4);
      if(!gridEl){ return; }
      if(!ps.length){ gridEl.innerHTML='<div class="maiS__msg">No encontramos nada para "'+esc(v)+'".</div>'; return; }
      gridEl.innerHTML=ps.map(function(p){
        var im=(p.featured_image&&(p.featured_image.url||p.featured_image))||p.image||'';
        return '<a class="maiS__card" href="'+p.url+'"><img src="'+thumb(im,700)+'" alt="'+esc(p.title)+'" loading="lazy"><div class="maiS__nm">'+esc(p.title)+'</div><div class="maiS__pr">'+(p.price||'')+'</div></a>';
      }).join('');
    }).catch(function(){});
  }
  function buildSearch(){
    if(ovS){ return; }
    var chips=CHIPS.map(function(c){ return '<a class="maiS__chip" href="'+c[1]+'">'+c[0]+'</a>'; }).join('');
    var inner='<div class="maiS__in"><div class="maiS__pill">'+ICO_SEARCH+'<input type="text" placeholder="Buscar productos..." aria-label="Buscar productos"><button type="button" class="maiS__clear">'+ICO_X+'</button></div>'
      +'<div class="maiS__lbl">Búsquedas populares</div><div class="maiS__chips">'+chips+'</div>'
      +'<div class="maiS__lbl">Productos sugeridos</div><div class="maiS__grid"></div></div>';
    ovS=mkOv('maiSov','maiS',inner);
    inputEl=ovS.querySelector('input');
    gridEl=ovS.querySelector('.maiS__grid');
    var clr=ovS.querySelector('.maiS__clear');
    inputEl.addEventListener('input',function(){
      var v=inputEl.value.trim();
      if(v){ clr.classList.add('on'); } else { clr.classList.remove('on'); }
      clearTimeout(tmr);
      if(!v){ fillDefault(); return; }
      tmr=setTimeout(function(){ search(v); },220);
    });
    inputEl.addEventListener('keydown',function(e){
      if(e.key==='Enter'){ var v=inputEl.value.trim(); if(v){ location.href='/search'+Q+'q='+encodeURIComponent(v); } }
    });
    clr.addEventListener('click',function(){ inputEl.value=''; clr.classList.remove('on'); fillDefault(); inputEl.focus(); });
    fillDefault();
  }
  function openSearch(){ buildSearch(); closeMega(); place(ovS); ovS.classList.add('on'); killDialogs(); setTimeout(killDialogs,60); setTimeout(function(){ if(inputEl){ inputEl.focus(); } },80); }

  function buildMega(){
    if(ovM){ return; }
    var cols=MCOLS.map(function(c){
      return '<div class="maiM__col"><div class="maiM__h">'+c[0]+'</div>'+c[1].map(function(l){ return '<a class="maiM__lk" href="'+l[1]+'">'+l[0]+'</a>'; }).join('')+'</div>';
    }).join('');
    var cards=MCARDS.map(function(c){
      return '<a class="maiM__card" href="'+c[1]+'" data-h="'+c[2]+'"><span class="maiM__cph"></span><div class="maiM__cnm">'+c[0]+'</div></a>';
    }).join('');
    ovM=mkOv('maiMov','maiM','<div class="maiM__in"><div class="maiM__cols">'+cols+'</div><div class="maiM__cards">'+cards+'</div></div>');
    [].forEach.call(ovM.querySelectorAll('.maiM__card'),function(a){
      getProd(a.getAttribute('data-h')).then(function(p){
        if(!p){ return; }
        var im=p.featured_image||(p.images&&p.images[0]);
        var ph=a.querySelector('.maiM__cph');
        if(!im||!ph){ return; }
        var g=document.createElement('img');
        g.src=thumb(im,520); g.loading='lazy';
        g.alt=a.querySelector('.maiM__cnm').textContent;
        a.replaceChild(g,ph);
      });
    });
    var pan=ovM.querySelector('.maiOv__panel');
    pan.addEventListener('mouseenter',function(){ clearTimeout(mtmr); });
    pan.addEventListener('mouseleave',function(){ schedCloseMega(); });
  }
  function closeMega(){ clearTimeout(mtmr); if(ovM){ ovM.classList.remove('on'); } if(tienda){ tienda.classList.remove('maiDot'); } }
  function schedCloseMega(){ clearTimeout(mtmr); mtmr=setTimeout(closeMega,200); }
  function openMega(){ clearTimeout(mtmr); buildMega(); if(ovS){ ovS.classList.remove('on'); } place(ovM); ovM.classList.add('on'); if(tienda){ tienda.classList.add('maiDot'); } }

  function wire(){
    if(!window.__MAI2W){
      window.__MAI2W=1;
      document.addEventListener('click',function(e){
        var t=e.target;
        if(!t||!t.closest){ return; }
        if(t.closest('.maiOv')){ return; }
        if(t.closest('.search-modal__button')){ e.preventDefault(); e.stopPropagation(); openSearch(); }
      },true);
      document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ closeAll(); } });
      window.addEventListener('resize',function(){ if(ovS&&ovS.classList.contains('on')){ place(ovS); } if(ovM&&ovM.classList.contains('on')){ place(ovM); } });
    }
    [].forEach.call(document.querySelectorAll('.search-modal__button'),function(b){
      if(b.getAttribute('data-mai2s')){ return; }
      b.setAttribute('data-mai2s','1');
      b.removeAttribute('on:click');
      b.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); openSearch(); });
    });
    var t=null;
    [].forEach.call(document.querySelectorAll('.menu-list__link'),function(a){ if(a.textContent.trim()==='Tienda'){ t=a; } });
    if(t&&!t.getAttribute('data-mai2')){
      t.setAttribute('data-mai2','1');
      tienda=t;
      t.addEventListener('mouseenter',function(){ if(window.innerWidth>=1000){ openMega(); } });
      t.addEventListener('mouseleave',function(){ schedCloseMega(); });
      t.addEventListener('click',function(e){
        if(window.innerWidth>=1000){ e.preventDefault(); if(ovM&&ovM.classList.contains('on')){ closeMega(); } else { openMega(); } }
      });
    }
  }

  function boot(){ try{ wire(); }catch(e){} }
  function schedBoot(){ clearTimeout(bt); bt=setTimeout(boot,120); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',boot); } else { boot(); }
  try{ new MutationObserver(schedBoot).observe(document.documentElement,{childList:true,subtree:true}); }catch(e){}
  setInterval(boot,2000);
  window.__MAI2=1;
})();


/* =========== MAI · paginas nuevas (nosotras, mai girls, ...) =========== */
(function(){
  var Q=String.fromCharCode(63);
  var F='/cdn/shop/files/';
  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function im(file,w,cls,alt){ return '<img class="'+(cls||'')+'" src="'+F+file+Q+'width='+w+'" alt="'+esc(alt||'')+'" loading="lazy" data-maiph="'+esc(file)+'">'; }
  function handleOf(){ var p=location.pathname; var k=p.indexOf('/pages/'); if(k<0){ return ''; } return p.slice(k+7).split('/')[0].split(Q)[0]; }
  function preview(){ var h=location.hash||''; var k=h.indexOf('mai='); return k<0?'':h.slice(k+4); }
  function which(){ return preview()||handleOf(); }
  function mount(cls,html){
    var main=document.querySelector('main');
    if(!main||main.getAttribute('data-mai3')){ return false; }
    main.setAttribute('data-mai3','1');
    main.className='maiP '+cls;
    main.innerHTML=html;
    return true;
  }
  document.addEventListener('error',function(e){
    var t=e.target;
    if(t&&t.tagName==='IMG'&&t.getAttribute('data-maiph')){
      var d=document.createElement('span');
      d.className=(t.className?t.className+' ':'')+'maiPh';
      d.textContent=t.getAttribute('data-maiph');
      if(t.parentNode){ t.parentNode.replaceChild(d,t); }
    }
  },true);

  var P_NACE='Paula había recorrido tiendas y miles de marcas buscando el bikini perfecto. Ese que se siente como una segunda piel, que se ve espectacular y que no te obliga a elegir entre verte bien y estar cómoda. Nunca lo encontró. Así que dejamos de buscarlo. Y decidimos crearlo. Un traje de baño pensado por mujeres que sabemos exactamente lo que queremos sentir cuando nos lo ponemos.';
  var P_WHY='Esta idea nació en Miami, esa ciudad le confirmó a Paula algo que ya llevábamos dentro: las latinas tenemos un fuego propio, una manera de ser hot sin esfuerzo. MAI es nuestro homenaje a eso. Y suena como my. Porque es justo lo que queremos que sientas cada vez que lo dices: que es tuyo, propio, absolutamente tuyo.';
  var P_MORE='Diseñamos trajes de baño, y lo hacemos con obsesión por el detalle porque creemos que en lo simple está lo importante. Cuando creamos MAI, lo pensamos como un acompañante para todas partes. Nuestros bikinis están hechos para ir más allá de la playa: llevarlos al gym, salir a la calle bajo un total look, pasar del mar a un almuerzo sin cambiarte. Son tan cómodos que se vuelven parte de tu vida, no solo de tus vacaciones.';
  var P_HOT1='Porque sentirse hot no va de gustarle a nadie, va de mirarte y saber que estás increíble. MAI es esa seguridad hecha tela. Sensualidad con clase, actitud sin esfuerzo.';
  var P_HOT2='Y todo esto nace de lo que somos: latinas, y se nota. En el color, en la calidez, en esa manera nuestra de habitar el cuerpo con confianza. MAI es una carta de amor a lo que somos: mujeres latinas que ocupan su lugar, disfrutan del sol y llevan su origen con orgullo a donde vayan.';

  function nosotras(){
    var f=[1,2,3,4,5].map(function(n){ return im('nace-'+n+'.jpg',500,'maiN__f maiN__f'+n,'MAI'); }).join('');
    var strip=[1,2,3].map(function(n){ return im('nace-'+n+'.jpg',500,'','MAI'); }).join('');
    var h=''
      +'<section class="maiN__hero"><h1 class="maiN__t">Nosotras</h1>'+im('nosotras-hero.jpg',1900,'maiN__heroimg','MAI Bikinis')+'</section>'
      +'<section class="maiN__nace"><div class="maiN__naceIn"><div class="maiN__eye">¿Cómo nace MAI?</div><h2 class="maiN__lead">Todo empezó con una búsqueda que nunca terminaba...</h2><p class="maiN__p">'+P_NACE+'</p><div class="maiN__strip">'+strip+'</div></div>'+f+'</section>'
      +'<section class="maiN__why"><div><h2 class="maiN__h2">¿Por qué MAI?</h2><p class="maiN__p">'+P_WHY+'</p></div><div class="maiN__pair">'+im('porque-mai-1.jpg',800,'','MAI')+im('porque-mai-2.jpg',800,'','MAI')+'</div></section>'
      +'<section class="maiN__more">'+im('mas-que-bikini.jpg',1200,'maiN__sq','MAI')+'<div><h2 class="maiN__h2">Más que un bikini ...</h2><p class="maiN__p">'+P_MORE+'</p></div></section>'
      +'<section class="maiN__hot">'+im('to-be-hot-1.jpg',900,'maiN__hotSide maiN__hotL','MAI')+im('to-be-hot-2.jpg',900,'maiN__hotSide maiN__hotR','MAI')+'<h2 class="maiN__hotT">TO BE HOT</h2><div class="maiN__hotIn"><div><h3 class="maiN__h3">Sentirse hot sin pedir permiso</h3><p class="maiN__p">'+P_HOT1+'</p></div><div><p class="maiN__p">'+P_HOT2+'</p></div></div></section>';
    return mount('maiN',h);
  }

  function girls(){
    var g='';
    for(var i=1;i<=12;i++){ g+=im('mai-girl-'+i+'.jpg',1200,'','MAI girl '+i); }
    var h='<section class="maiG__hero"><h1 class="maiG__t">mai girls</h1><div class="maiG__note">¿La próxima MAI girl? Sube tu foto etiquetándonos en IG <a href="https://www.instagram.com/maiswimsuits/" target="_blank" rel="noopener">@maiswimsuits</a> y la próxima podrías ser tú...</div></section>'
      +'<section class="maiG__grid">'+g+'</section>';
    return mount('maiG',h);
  }

  var ROUTES={'nosotras':nosotras,'sobre-nosotras':nosotras,'mai-girls':girls};

  function run(){
    var k=which();
    var fn=ROUTES[k];
    if(fn){ try{ fn(); }catch(e){} }
  }
  var bt=null;
  function sched(){ clearTimeout(bt); bt=setTimeout(run,80); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run); } else { run(); }
  try{ new MutationObserver(sched).observe(document.documentElement,{childList:true,subtree:true}); }catch(e){}
  window.addEventListener('hashchange',function(){ var m=document.querySelector('main'); if(m){ m.removeAttribute('data-mai3'); } run(); });
  window.__MAI3=1;
})();


/* =========== MAI · paginas 2 (contacto, tallas, cuidados, legal, 404) =========== */
(function(){
  var Q=String.fromCharCode(63);
  var F='/cdn/shop/files/';
  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function im(file,w,cls,alt){ return '<img class="'+(cls||'')+'" src="'+F+file+Q+'width='+w+'" alt="'+esc(alt||'')+'" loading="lazy" data-maiph="'+esc(file)+'">'; }
  function handleOf(){ var p=location.pathname; var k=p.indexOf('/pages/'); if(k<0){ return ''; } return p.slice(k+7).split('/')[0].split(Q)[0]; }
  function preview(){ var h=location.hash||''; var k=h.indexOf('mai='); return k<0?'':h.slice(k+4); }
  function which(){ return preview()||handleOf(); }
  function mount(cls,html){
    var main=document.querySelector('main');
    if(!main||main.getAttribute('data-mai3')){ return false; }
    main.setAttribute('data-mai3','1');
    main.className='maiP '+cls;
    main.innerHTML=html;
    return true;
  }
  function pageTitle(){ var t=document.title||''; var i=t.lastIndexOf(' – '); return i>0?t.slice(0,i):t; }

  /* ---------- CONTACTANOS ---------- */
  var ASUNTOS=['Estado de mi pedido','Cambios y devoluciones','Dudas de talla','Garantia de un producto','Colaboraciones y prensa','Otro'];
  function contacto(){
    var ok=(location.search||'').indexOf('contact_posted=true')>=0;
    var opts='<option value="" disabled selected>Selecciona el motivo de tu mensaje</option>'+ASUNTOS.map(function(a){ return '<option value="'+esc(a)+'">'+esc(a)+'</option>'; }).join('');
    var okBox=ok?'<div class="maiC2__ok">Gracias por escribirnos. Recibimos tu mensaje y te responderemos dentro de 24 a 48 horas hábiles.</div>':'';
    var form='<form method="post" action="/contact#contact_form" accept-charset="UTF-8" id="contact_form">'
      +'<input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="on">'
      +okBox
      +'<div class="maiC2__fld"><label class="maiC2__lbl" for="maiCn">Nombre completo</label><input id="maiCn" type="text" name="contact[name]" placeholder="Escribe tu nombre y apellido" required></div>'
      +'<div class="maiC2__fld"><label class="maiC2__lbl" for="maiCe">Correo electrónico</label><input id="maiCe" type="email" name="contact[email]" placeholder="ejemplo@correo.com" required></div>'
      +'<div class="maiC2__fld"><label class="maiC2__lbl" for="maiCs">Asunto</label><select id="maiCs" name="contact[Asunto]">'+opts+'</select></div>'
      +'<div class="maiC2__fld"><label class="maiC2__lbl" for="maiCb">Mensaje</label><textarea id="maiCb" name="contact[body]" placeholder="Cuéntanos cómo podemos ayudarte..." required></textarea></div>'
      +'<button class="maiC2__btn" type="submit">Enviar mensaje</button></form>';
    var info='<div><h3 class="maiC2__h3">Información de contacto</h3>'
      +'<div class="maiC2__row"><span class="maiC2__ico">✉</span><div><div class="maiC2__k">Email</div><div class="maiC2__v"><a href="mailto:hola@maiswimwear.com">hola@maiswimwear.com</a></div></div></div>'
      +'<div class="maiC2__row"><span class="maiC2__ico">◎</span><div><div class="maiC2__k">Instagram</div><div class="maiC2__v"><a href="https://www.instagram.com/maiswimsuits/" target="_blank" rel="noopener">@maiswimsuits</a></div></div></div>'
      +'<div class="maiC2__row"><span class="maiC2__ico">◷</span><div><div class="maiC2__k">Horario</div><div class="maiC2__v">Lunes a viernes, 9:00 – 18:00 (CLT)</div></div></div>'
      +'<p class="maiC2__note">Responderemos tu mensaje en un plazo de 24-48 horas hábiles.</p></div>';
    return mount('maiC2','<h1 class="maiC2__t">Contáctanos</h1><div class="maiC2__in">'+form+info+'</div>');
  }

  /* ---------- GUIA DE TALLAS ---------- */
  var PASOS=[['Busto','Mide alrededor de la parte más ancha de tu busto, manteniendo la cinta métrica horizontal.'],['Cintura','Mide alrededor de la parte más estrecha de tu cintura, justo encima del ombligo.'],['Cadera','Mide alrededor de la parte más ancha de tus caderas.']];
  var TOPS=[['XS','80-84','68-72','A-B'],['S','84-88','72-76','B-C'],['M','88-92','76-80','C-D'],['L','92-96','80-84','D-E']];
  var BOTS=[['XS','60-64','86-90'],['S','64-68','90-94'],['M','68-72','94-98'],['L','72-76','98-102']];
  var TIPS=[['¿Entre dos tallas?','Si estás entre dos tallas, te recomendamos elegir la talla más grande para mayor comodidad.'],['Top y bottom diferente','Puedes combinar tallas distintas en top y bottom. No tienes que usar la misma talla en ambos.'],['Primera compra','Si es tu primera vez comprando, mídete con una cinta métrica flexible para asegurar el mejor calce.']];
  function tabla(heads,rows){
    var h='<div class="maiT__wrap"><table class="maiT__tbl"><thead><tr>'+heads.map(function(x){ return '<th>'+x+'</th>'; }).join('')+'</tr></thead><tbody>';
    h+=rows.map(function(r){ return '<tr>'+r.map(function(c){ return '<td>'+c+'</td>'; }).join('')+'</tr>'; }).join('');
    return h+'</tbody></table></div>';
  }
  function tallas(){
    var svg='<svg width="180" height="136" viewBox="0 0 180 136" fill="none" stroke="#c4c4c4" stroke-width="1.4"><line x1="30" y1="1" x2="150" y2="1"></line><circle cx="90" cy="56" r="32"></circle><line x1="0" y1="113" x2="180" y2="113"></line><line x1="30" y1="135" x2="150" y2="135"></line></svg>';
    var pasos=PASOS.map(function(p,i){ return '<div><div class="maiT__num">'+(i+1)+'</div><div class="maiT__st">'+(i+1)+'. '+p[0]+'</div><p class="maiT__sd">'+p[1]+'</p></div>'; }).join('');
    var tips=TIPS.map(function(t){ return '<div class="maiT__tip"><div class="maiT__tipT">'+t[0]+'</div><p class="maiT__tipC">'+t[1]+'</p></div>'; }).join('');
    var h='<section class="maiT__hero"><h1 class="maiT__t">Guía de tallas</h1><p class="maiT__sub">Encuentra tu talla perfecta</p></section>'
      +'<section class="maiT__sec"><h2 class="maiT__h2">Cómo tomar tus medidas</h2><div class="maiT__steps">'+pasos+'</div><div class="maiT__diag">'+svg+'<div class="maiT__diagL">DIAGRAMA DE MEDIDAS</div></div></section>'
      +'<section class="maiT__sec"><div class="maiT__tt">Tops</div>'+tabla(['Talla','Busto (cm)','Bajo busto (cm)','Copa sugerida'],TOPS)
      +'<div class="maiT__tt">Bottoms</div>'+tabla(['Talla','Cintura (cm)','Cadera (cm)'],BOTS)+'</section>'
      +'<section class="maiT__sec"><h2 class="maiT__h2">Tips para elegir tu talla</h2><div class="maiT__tips">'+tips+'</div></section>';
    return mount('maiT',h);
  }

  /* ---------- GUIA DE CUIDADOS ---------- */
  var PASOS6=[['💧','Lavar a mano','Lava tu bikini a mano con agua fría después de cada uso. Esto ayuda a eliminar el cloro, la sal y el protector solar.'],['🚫','No usar lavadora','La lavadora puede dañar las fibras y deformar tu bikini. Siempre lávalo a mano con un jabón suave.'],['☀️','Secar a la sombra','Nunca lo pongas en la secadora. Déjalo secar al aire libre, a la sombra, para proteger el color y la elasticidad.'],['🧴','Sin químicos','No utilices cloro, blanqueadores ni detergentes agresivos. Un jabón neutro es todo lo que necesitas.'],['👙','Cuidado con superficies','Evita el contacto prolongado con superficies ásperas como bordes de piscina o arena gruesa para proteger la tela.'],['📦','Guardado correcto','Guárdalo seco y plano, sin dobleces fuertes. Evita dejarlo húmedo en una bolsa por mucho tiempo.']];
  var HAZLO=['Enjuagar después de cada uso','Lavar con agua fría y jabón neutro','Secar a la sombra y al aire libre','Guardar seco y en lugar fresco','Alternar entre bikinis'];
  var EVITA=['Usar lavadora o secadora','Aplicar cloro o blanqueadores','Retorcer para escurrir','Planchar','Dejarlo húmedo guardado'];
  function cuidados(){
    var cards=PASOS6.map(function(p){ return '<div class="maiCu__card"><div class="maiCu__em">'+p[0]+'</div><div class="maiCu__ct">'+p[1]+'</div><p class="maiCu__cc">'+p[2]+'</p></div>'; }).join('');
    var si=HAZLO.map(function(x){ return '<div class="maiCu__li"><span>✓</span><span>'+x+'</span></div>'; }).join('');
    var no=EVITA.map(function(x){ return '<div class="maiCu__li"><span>✕</span><span>'+x+'</span></div>'; }).join('');
    var h='<section class="maiCu__hero"><h1 class="maiCu__t">Cuidados de tu bikini</h1><p class="maiCu__sub">Para que dure muchas temporadas</p></section>'
      +'<div style="padding:0 clamp(16px,4vw,64px)">'+im('cuidados-banner.jpg',1800,'maiCu__ban','Cuidados MAI')+'</div>'
      +'<p class="maiCu__intro">Nuestros bikinis están hechos con 80% poliamida y 20% elastano, una combinación que entrega ajuste, elasticidad y secado rápido. Con los cuidados correctos, tu bikini mantendrá su forma y color por mucho más tiempo.</p>'
      +'<section class="maiCu__sec"><h2 class="maiT__h2">6 pasos para cuidar tu bikini</h2><div class="maiCu__grid">'+cards+'</div></section>'
      +'<section class="maiCu__sec"><div class="maiCu__two"><div class="maiCu__box"><div class="maiCu__bt">✓ Hazlo</div>'+si+'</div><div class="maiCu__box"><div class="maiCu__bt">✕ Evítalo</div>'+no+'</div></div></section>'
      +'<p class="maiCu__end">Con estos sencillos cuidados, tu bikini MAI te acompañará por muchas temporadas.</p>';
    return mount('maiCu',h);
  }

  /* ---------- LEGALES ---------- */
  function legal(){
    var main=document.querySelector('main');
    if(!main||main.getAttribute('data-mai3')){ return false; }
    var rte=main.querySelector('rte-formatter');
    if(!rte||!rte.innerHTML||rte.innerHTML.length<200){ return false; }
    var body=rte.innerHTML;
    var h1=main.querySelector('h1');
    var title=h1?h1.textContent.trim():pageTitle();
    main.setAttribute('data-mai3','1');
    main.className='maiP maiL';
    main.innerHTML='<h1 class="maiL__t">'+esc(title)+'</h1><div class="maiL__rule"></div><div class="maiL__body">'+body+'</div>';
    return true;
  }

  /* ---------- 404 ---------- */
  function notFound(){
    var h='<div class="mai404__n">404</div><h1 class="mai404__t">Esta página se fue a la playa</h1>'
      +'<p class="mai404__p">El link que seguiste no existe o cambió de lugar. Vuelve al inicio o mira lo que tenemos ahora.</p>'
      +'<div class="mai404__btns"><a class="mai404__b mai404__b--fill" href="/">Ir al inicio</a><a class="mai404__b" href="/collections/the-essentials">Ver la colección</a></div>';
    return mount('mai404',h);
  }

  var ROUTES={'contact':contacto,'contactanos':contacto,'tallas':tallas,'guia-de-tallas':tallas,'guia-de-cuidados':cuidados,'cuidados':cuidados,
    'terminos-y-condiciones':legal,'politica-de-envios':legal,'politica-de-cambios-y-devoluciones':legal,'politica-de-garantia':legal,'politica-de-privacidad':legal,'aviso-legal':legal,'envios-y-cambios':legal,'sobre-nosotras':legal};

  function run(){
    var k=which();
    var fn=ROUTES[k];
    if(!fn&&location.pathname.indexOf('/policies/')>=0){ fn=legal; }
    if(!fn&&(document.title||'').indexOf('404')>=0){ fn=notFound; }
    if(fn){ try{ fn(); }catch(e){} }
  }
  var bt=null;
  function sched(){ clearTimeout(bt); bt=setTimeout(run,80); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run); } else { run(); }
  try{ new MutationObserver(sched).observe(document.documentElement,{childList:true,subtree:true}); }catch(e){}
  window.addEventListener('hashchange',function(){ var m=document.querySelector('main'); if(m){ m.removeAttribute('data-mai3'); } run(); });
  window.__MAI4=1;
})();


/* =========== MAI · ajustes v3: header, footer, ALL, popup tallas =========== */
(function(){
  var Q=String.fromCharCode(63);
  var IG='https://www.instagram.com/maiswimsuits/';
  var TT='https://www.tiktok.com/@maiswimwear';
  var F='/cdn/shop/files/';
  var CACHE={};
  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function money(c){ var s=String(Math.round(c/100)), o='', k=0;
    for(var i=s.length-1;i>=0;i--){ o=s.charAt(i)+o; k++; if(k%3===0&&i>0){ o='.'+o; } }
    return '$'+o; }
  function thumb(u,w){ if(!u){ return ''; } return String(u).split(Q)[0]+Q+'width='+w; }
  function topPx(){ var h=document.getElementById('header-component'); if(!h){ return 66; } return Math.max(0,Math.round(h.getBoundingClientRect().bottom)); }
  function getProd(h){ if(CACHE[h]){ return Promise.resolve(CACHE[h]); }
    return fetch('/products/'+h+'.js').then(function(r){ return r.json(); }).then(function(j){ CACHE[h]=j; return j; }).catch(function(){ return null; }); }

  /* ---- 1) fuera Conjuntos del mega-menu Tienda ---- */
  function noConjuntos(){
    [].forEach.call(document.querySelectorAll('.maiM__lk'),function(a){
      if(a.textContent.trim()==='Conjuntos'&&a.parentNode){ a.parentNode.removeChild(a); }
    });
  }

  /* ---- 2) dropdown Nosotras ---- */
  var NLINKS=[['Historia','/pages/nosotras'],['FAQs','/pages/preguntas-frecuentes'],['MAI Girls','/pages/mai-girls'],['Contáctanos','/pages/contact']];
  var ovN=null, nLink=null, ntmr=null;
  function closeN(){ clearTimeout(ntmr); if(ovN){ ovN.classList.remove('on'); } if(nLink){ nLink.classList.remove('maiDot'); } }
  function schedCloseN(){ clearTimeout(ntmr); ntmr=setTimeout(closeN,200); }
  function buildN(){
    if(ovN){ return; }
    var lks=NLINKS.map(function(l){ return '<a class="maiM__lk" href="'+l[1]+'">'+l[0]+'</a>'; }).join('');
    var d=document.createElement('div');
    d.id='maiNov'; d.className='maiOv maiM';
    d.innerHTML='<div class="maiOv__dim"></div><div class="maiOv__panel"><div class="maiM__in"><div class="maiM__cols"><div class="maiM__col"><div class="maiM__h">Nosotras</div>'+lks+'</div></div></div></div>';
    document.body.appendChild(d);
    d.querySelector('.maiOv__dim').addEventListener('click',closeN);
    var p=d.querySelector('.maiOv__panel');
    p.addEventListener('mouseenter',function(){ clearTimeout(ntmr); });
    p.addEventListener('mouseleave',schedCloseN);
    ovN=d;
  }
  function openN(){
    clearTimeout(ntmr); buildN();
    var a=document.getElementById('maiMov'); if(a){ a.classList.remove('on'); }
    var b=document.getElementById('maiSov'); if(b){ b.classList.remove('on'); }
    ovN.querySelector('.maiOv__panel').style.top=topPx()+'px';
    ovN.classList.add('on');
    if(nLink){ nLink.classList.add('maiDot'); }
  }
  function wireNav(){
    [].forEach.call(document.querySelectorAll('.menu-list__link'),function(a){
      var t=a.textContent.trim();
      if(t==='Nosotras'&&!a.getAttribute('data-mainos')){
        a.setAttribute('data-mainos','1'); nLink=a;
        a.addEventListener('mouseenter',function(){ if(window.innerWidth>=1000){ openN(); } });
        a.addEventListener('mouseleave',schedCloseN);
        a.addEventListener('click',function(e){ if(window.innerWidth>=1000){ e.preventDefault(); if(ovN&&ovN.classList.contains('on')){ closeN(); } else { openN(); } } });
      }
      if((t==='Tienda'||t==='Colecciones')&&!a.getAttribute('data-mainc')){
        a.setAttribute('data-mainc','1');
        a.addEventListener('mouseenter',closeN);
      }
    });
    if(!window.__MAINESC){ window.__MAINESC=1; document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ closeN(); } }); }
  }

  /* ---- 3) footer ---- */
  var FCOLS=[
    ['Nosotras',[['Historia','/pages/nosotras'],['FAQs','/pages/preguntas-frecuentes'],['MAI Girls','/pages/mai-girls'],['Contáctanos','/pages/contact']]],
    ['Colecciones',[['The Essentials','/collections/the-essentials']]],
    ['Ayuda',[['Guía de cuidados','/pages/guia-de-cuidados'],['Buscar','/search'],['Mi cuenta','/account'],['Carrito','/cart']]],
    ['Seguridad y políticas',[['Términos y condiciones','/pages/terminos-y-condiciones'],['Política de privacidad','/pages/politica-de-privacidad'],['Política de envíos','/pages/politica-de-envios'],['Cambios y devoluciones','/pages/politica-de-cambios-y-devoluciones'],['Política de garantía','/pages/politica-de-garantia'],['Aviso legal','/pages/aviso-legal']]]
  ];
  function fixFooter(){
    var f=document.querySelector('.maiF');
    if(!f||f.getAttribute('data-maif3')){ return; }
    var cols=f.querySelector('.maiF__cols');
    if(!cols){ return; }
    f.setAttribute('data-maif3','1');
    cols.innerHTML=FCOLS.map(function(c){
      return '<div class="maiF__col"><h4>'+c[0]+'</h4><ul>'+c[1].map(function(l){ return '<li><a href="'+l[1]+'">'+l[0]+'</a></li>'; }).join('')+'</ul></div>';
    }).join('');
    [].forEach.call(f.querySelectorAll('a'),function(a){
      var h=a.getAttribute('href')||'';
      if(h.indexOf('instagram.com')>=0){ a.setAttribute('href',IG); }
      if(h.indexOf('tiktok.com')>=0){ a.setAttribute('href',TT); }
      if(a.textContent.trim()==='Política de privacidad'){ a.setAttribute('href','/pages/politica-de-privacidad'); }
    });
  }
  function fixIg(){
    [].forEach.call(document.querySelectorAll('.maiG__note a'),function(a){
      if(a.getAttribute('data-maiig')){ return; }
      a.setAttribute('data-maiig','1'); a.setAttribute('href',IG); a.textContent='@maiswimwear';
    });
  }

  /* ---- 4) popup guia de tallas ---- */
  var GTOPS=[['XS','80-84','68-72','A-B'],['S','84-88','72-76','B-C'],['M','88-92','76-80','C-D'],['L','92-96','80-84','D-E']];
  var GBOTS=[['XS','60-64','86-90'],['S','64-68','90-94'],['M','68-72','94-98'],['L','72-76','98-102']];
  function gtabla(heads,rows){
    var h='<div class="maiT__wrap"><table class="maiT__tbl"><thead><tr>'+heads.map(function(x){ return '<th>'+x+'</th>'; }).join('')+'</tr></thead><tbody>';
    h+=rows.map(function(r){ return '<tr>'+r.map(function(c){ return '<td>'+c+'</td>'; }).join('')+'</tr>'; }).join('');
    return h+'</tbody></table></div>';
  }
  var ovT=null;
  function closeT(){ if(ovT){ ovT.classList.remove('on'); } }
  function buildT(){
    if(ovT){ return; }
    var d=document.createElement('div');
    d.id='maiGTov'; d.className='maiGT';
    d.innerHTML='<div class="maiGT__dim"></div><div class="maiGT__box"><button class="maiGT__x" type="button" aria-label="Cerrar">×</button>'
      +'<h2 class="maiGT__t">Guía de tallas</h2>'
      +'<p class="maiGT__s">Todas las medidas en centímetros. Si estás entre dos tallas, elige la más grande. Puedes combinar tallas distintas en top y bottom.</p>'
      +'<div class="maiT__tt">Tops</div>'+gtabla(['Talla','Busto (cm)','Bajo busto (cm)','Copa sugerida'],GTOPS)
      +'<div class="maiT__tt">Bottoms</div>'+gtabla(['Talla','Cintura (cm)','Cadera (cm)'],GBOTS)
      +'<p class="maiGT__note">¿Dudas con tu talla? Escríbenos a hola@maiswimwear.com y te ayudamos.</p></div>';
    document.body.appendChild(d);
    d.querySelector('.maiGT__dim').addEventListener('click',closeT);
    d.querySelector('.maiGT__x').addEventListener('click',closeT);
    ovT=d;
  }
  function openT(){ buildT(); ovT.classList.add('on'); }
  function wireT(){
    if(location.pathname.indexOf('/products/')<0){ return; }
    var main=document.querySelector('main');
    if(!main){ return; }
    [].forEach.call(main.querySelectorAll('a,span,button,div,p'),function(el){
      if(el.children.length){ return; }
      var t=el.textContent.trim().toLowerCase();
      if(t!=='guía de tallas'&&t!=='guia de tallas'&&t!=='ver guía de tallas'){ return; }
      if(el.getAttribute('data-maigt')){ return; }
      el.setAttribute('data-maigt','1');
      el.classList.add('maiGTlink');
      el.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); openT(); });
    });
    if(!window.__MAIGTESC){ window.__MAIGTESC=1; document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ closeT(); } }); }
  }

  /* ---- 5) pagina ALL ---- */
  var HEX={'Rojo':'#d1252a','Celeste':'#68c7e6','Amarillo':'#f4cf3f','Wine':'#6e1f2e','Perla':'#ece5da','Caramel':'#a76a37'};
  var APROD=[['top-pipa','Pipa','Tops'],['top-saona','Saona','Tops'],['bottom-pipa','Pipa','Bottoms'],['bottom-saona','Saona','Bottoms']];
  var AHERO=['toppngmaiceleststepipa.png','bottom_ngmairedpipa..png','toppngmaicamarillopipa..png','bottommpngmaiceleststepipa..png'];
  var FST={modelo:'',tipo:'',color:'',talla:''};
  var hi=0, htmr=null;

  function heroRotate(){
    clearInterval(htmr);
    htmr=setInterval(function(){
      var img=document.querySelector('.maiA2 .maiW__img img');
      if(!img){ clearInterval(htmr); return; }
      hi=(hi+1)%AHERO.length;
      img.setAttribute('src',F+AHERO[hi]+Q+'width=900');
    },2600);
  }
  function syncChips(){
    [].forEach.call(document.querySelectorAll('.maiA2__chip'),function(b){
      var k=b.getAttribute('data-k'), v=b.getAttribute('data-v');
      if(FST[k]===v){ b.classList.add('on'); } else { b.classList.remove('on'); }
    });
  }
  function applyF(){
    var n=0;
    [].forEach.call(document.querySelectorAll('.maiA2 .maiH__card'),function(c){
      var ok=true;
      if(FST.modelo&&c.getAttribute('data-modelo')!==FST.modelo){ ok=false; }
      if(FST.tipo&&c.getAttribute('data-tipo')!==FST.tipo){ ok=false; }
      if(FST.color&&c.getAttribute('data-color')!==FST.color){ ok=false; }
      if(FST.talla&&String(c.getAttribute('data-sizes')||'').split(',').indexOf(FST.talla)<0){ ok=false; }
      if(ok){ c.classList.remove('maiOff'); n++; } else { c.classList.add('maiOff'); }
    });
    var cnt=document.getElementById('maiA2count');
    if(cnt){ cnt.textContent=n+(n===1?' producto':' productos'); }
    var emp=document.getElementById('maiA2empty');
    if(emp){ emp.style.display=n?'none':'block'; }
  }
  function buildBar(colors,sizes){
    var bar=document.getElementById('maiA2bar');
    if(!bar||bar.getAttribute('data-w')){ return; }
    bar.setAttribute('data-w','1');
    function grp(lbl,key,vals,sw){
      return '<div class="maiA2__grp"><span class="maiA2__lbl">'+lbl+'</span>'+vals.map(function(v){
        return '<button class="maiA2__chip" type="button" data-k="'+key+'" data-v="'+esc(v)+'">'+(sw?'<span class="maiA2__sw" style="background:'+(HEX[v]||'#ddd')+'"></span>':'')+esc(v)+'</button>';
      }).join('')+'</div>';
    }
    bar.innerHTML=grp('Modelo','modelo',['Pipa','Saona'],false)
      +grp('Tipo','tipo',['Tops','Bottoms'],false)
      +grp('Color','color',colors,true)
      +grp('Talla','talla',sizes,false)
      +'<div class="maiA2__right"><span class="maiA2__count" id="maiA2count"></span><button class="maiA2__clear" type="button" id="maiA2clear">Limpiar</button></div>';
    bar.addEventListener('click',function(e){
      var t=e.target;
      if(!t||!t.closest){ return; }
      if(t.id==='maiA2clear'){ FST={modelo:'',tipo:'',color:'',talla:''}; syncChips(); applyF(); return; }
      var b=t.closest('.maiA2__chip');
      if(!b){ return; }
      var k=b.getAttribute('data-k'), v=b.getAttribute('data-v');
      FST[k]=(FST[k]===v)?'':v;
      syncChips(); applyF();
    });
  }
  function wireDots(){
    var g=document.getElementById('maiA2grid');
    if(!g||g.getAttribute('data-w')){ return; }
    g.setAttribute('data-w','1');
    g.addEventListener('click',function(e){
      var t=e.target;
      if(!t||!t.closest){ return; }
      var d=t.closest('.maiH__dot');
      if(!d||!d.getAttribute('data-a2')){ return; }
      var card=d.closest('.maiH__card');
      if(!card){ return; }
      var img=card.querySelector('.maiH__img');
      if(img){ img.setAttribute('src',d.getAttribute('data-img')); }
      var lbl=card.querySelector('.maiH__color');
      if(lbl){ lbl.textContent=d.getAttribute('data-name'); }
      card.setAttribute('data-color',d.getAttribute('data-name'));
      card.setAttribute('data-sizes',d.getAttribute('data-sizes')||'');
      var href='/products/'+card.getAttribute('data-h')+Q+'variant='+d.getAttribute('data-variant');
      [].forEach.call(card.querySelectorAll('a'),function(a){ a.setAttribute('href',href); });
      [].forEach.call(card.querySelectorAll('.maiH__dot'),function(x){ x.classList.remove('on'); });
      d.classList.add('on');
      applyF();
    });
  }
  function loadGrid(){
    Promise.all(APROD.map(function(x){ return getProd(x[0]); })).then(function(list){
      var items=[], colorSet=[], sizeSet=[];
      list.forEach(function(p,ix){
        if(!p){ return; }
        var meta=APROD[ix], m={}, colors=[];
        (p.variants||[]).forEach(function(v){
          var c=(v.options&&v.options[0])||'';
          if(!c){ return; }
          if(!m[c]){ m[c]={n:c,img:(v.featured_image&&v.featured_image.src)||p.featured_image||'',vid:v.id,sizes:[]}; colors.push(m[c]); }
          var s=(v.options&&v.options[1])||'';
          if(s&&m[c].sizes.indexOf(s)<0){ m[c].sizes.push(s); }
          if(s&&sizeSet.indexOf(s)<0){ sizeSet.push(s); }
        });
        var dots=colors.map(function(cc){ return '<span class="maiH__dot" data-a2="1" data-img="'+thumb(cc.img,700)+'" data-name="'+esc(cc.n)+'" data-variant="'+cc.vid+'" data-sizes="'+cc.sizes.join(',')+'" style="background:'+(HEX[cc.n]||'#ddd')+'" title="'+esc(cc.n)+'"></span>'; }).join('');
        colors.forEach(function(c,ci){
          if(colorSet.indexOf(c.n)<0){ colorSet.push(c.n); }
          var href='/products/'+p.handle+Q+'variant='+c.vid;
          var html='<div class="maiH__card" data-h="'+p.handle+'" data-modelo="'+meta[1]+'" data-tipo="'+meta[2]+'" data-color="'+esc(c.n)+'" data-sizes="'+c.sizes.join(',')+'">'
            +'<a class="maiH__imglink" href="'+href+'"><div class="maiH__imgbox"><img class="maiH__img" src="'+thumb(c.img,700)+'" alt="'+esc(p.title)+'" loading="lazy"></div></a>'
            +'<div class="maiH__dots">'+dots+'</div>'
            +'<div class="maiH__meta"><a class="maiH__namelink" href="'+href+'"><span class="maiH__name">'+esc(p.title)+'</span></a><span class="maiH__price">'+money(p.price)+'</span></div>'
            +'<p class="maiH__color">'+esc(c.n)+'</p></div>';
          items.push({k:ci*10+ix,h:html});
        });
      });
      items.sort(function(a,b){ return a.k-b.k; });
      var g=document.getElementById('maiA2grid');
      if(g){ g.innerHTML=items.map(function(x){ return x.h; }).join(''); }
      buildBar(colorSet,sizeSet);
      wireDots();
      syncChips();
      applyF();
    });
  }
  function buildAll(){
    if(location.pathname.indexOf('/collections/all')<0){ return; }
    var main=document.querySelector('main');
    if(!main||main.querySelector('.maiA2__bar')){ return; }
    main.setAttribute('data-maic','1');
    main.setAttribute('data-mai3','1');
    main.className='maiP maiA2';
    main.innerHTML='<div class="maiC">'
      +'<section class="maiW"><div class="maiW__in"><h1 class="maiW__word">ALL</h1><div class="maiW__img"><img src="'+F+AHERO[0]+Q+'width=900" alt="MAI"></div></div></section>'
      +'<div class="maiA2__bar" id="maiA2bar"></div>'
      +'<div class="maiSec"><div class="maiSec__in"><div class="maiWgrid maiAgrid" id="maiA2grid"></div><div class="maiA2__empty" id="maiA2empty" style="display:none">No hay productos con esos filtros.</div></div></div>'
      +'<div class="maiCban"><img src="'+F+'conoce-mai.png'+Q+'width=1900" alt="CONOCE MAI"></div>'
      +'</div>';
    heroRotate();
    loadGrid();
  }

  function all3(){
    try{ noConjuntos(); }catch(e){}
    try{ wireNav(); }catch(e){}
    try{ fixFooter(); }catch(e){}
    try{ fixIg(); }catch(e){}
    try{ wireT(); }catch(e){}
    try{ buildAll(); }catch(e){}
  }
  var bt=null;
  function sched(){ clearTimeout(bt); bt=setTimeout(all3,120); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',all3); } else { all3(); }
  try{ new MutationObserver(sched).observe(document.documentElement,{childList:true,subtree:true}); }catch(e){}
  setInterval(all3,2000);
  window.__MAI5=1;
})();


/* =========== MAI · v4: pop-up guía de tallas (trigger PDP) =========== */
(function(){
  if(window.__MAI6){ return; }
  window.__MAI6=1;
  var Q=String.fromCharCode(63);
  var F='/cdn/shop/files/';
  var TOPS=[['XS','80-84','68-72','A-B'],['S','84-88','72-76','B-C'],['M','88-92','76-80','C-D'],['L','92-96','80-84','D-E']];
  var BOTS=[['XS','60-64','86-90'],['S','64-68','90-94'],['M','68-72','94-98'],['L','72-76','98-102']];
  function handle(){
    var p=location.pathname.split('/products/')[1]||'';
    return p.split(Q)[0].split('/')[0].toLowerCase();
  }
  function isTop(){ return handle().indexOf('top')===0; }
  function nice(){
    var h=handle();
    var m=h.indexOf('pipa')>=0?'Pipa':(h.indexOf('saona')>=0?'Saona':(h.indexOf('tayrona')>=0?'Tayrona':''));
    return (isTop()?'Top':'Bottom')+(m?' '+m:'');
  }
  function tbl(){
    var rows=isTop()?TOPS:BOTS;
    var head=isTop()?['Talla','Busto (cm)','Bajo busto (cm)','Copa']:['Talla','Cintura (cm)','Cadera (cm)'];
    var s='<table class="maiT__tbl"><thead><tr>';
    for(var i=0;i<head.length;i++){ s+='<th>'+head[i]+'</th>'; }
    s+='</tr></thead><tbody>';
    for(var r=0;r<rows.length;r++){
      s+='<tr>';
      for(var c=0;c<rows[r].length;c++){ s+='<td>'+rows[r][c]+'</td>'; }
      s+='</tr>';
    }
    return s+'</tbody></table>';
  }
  var ov=null;
  function close(){
    if(ov){ ov.classList.remove('on'); }
    document.documentElement.style.overflow='';
  }
  function build(){
    if(ov){ return ov; }
    ov=document.createElement('div');
    ov.className='maiGT';
    ov.id='maiGTov2';
    var img=F+'guia-tallas-'+handle()+'.png'+Q+'width=1200';
    ov.innerHTML='<div class="maiGT__dim"></div>'
      +'<div class="maiGT__box">'
      +'<button class="maiGT__x" type="button" aria-label="Cerrar">'+String.fromCharCode(215)+'</button>'
      +'<h3 class="maiGT__t">Guía de tallas</h3>'
      +'<p class="maiGT__s">'+nice()+'</p>'
      +'<img class="maiGT__img" id="maiGTimg" src="'+img+'" alt="Guía de tallas" style="display:none">'
      +'<div id="maiGTfb">'+tbl()
      +'<p class="maiGT__note">Medidas en centímetros. Si estás entre dos tallas, te recomendamos elegir la mayor.</p></div>'
      +'</div>';
    document.body.appendChild(ov);
    var im=ov.querySelector('#maiGTimg');
    im.addEventListener('load',function(){
      im.style.display='block';
      var fb=ov.querySelector('#maiGTfb');
      if(fb){ fb.style.display='none'; }
    });
    ov.querySelector('.maiGT__dim').addEventListener('click',close);
    ov.querySelector('.maiGT__x').addEventListener('click',close);
    return ov;
  }
  function open(){
    build().classList.add('on');
    document.documentElement.style.overflow='hidden';
  }
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ close(); } });
  function wireOne(el){
    if(el.getAttribute('data-maigt')){ return; }
    el.setAttribute('data-maigt','1');
    el.classList.add('maiGTlink');
    el.addEventListener('click',function(ev){ ev.preventDefault(); ev.stopPropagation(); open(); });
  }
  function wire(){
    if(location.pathname.indexOf('/products/')<0){ return; }
    [].forEach.call(document.querySelectorAll('.maiPD__guide'),wireOne);
    [].forEach.call(document.querySelectorAll('a,span,button,div,p,li'),function(el){
      if(el.children.length){ return; }
      var t=(el.textContent||'').trim().toLowerCase();
      if(t.length>32){ return; }
      if(t.indexOf('guía de tallas')<0&&t.indexOf('guia de tallas')<0){ return; }
      wireOne(el);
    });
  }
  function run(){ try{ wire(); }catch(e){} }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run); } else { run(); }
  setInterval(run,1500);
})();


/* =========== MAI · v5: drawer + moneda/idioma + orden + fixes =========== */
(function(){
  if(window.__MAI7){ return; }
  window.__MAI7=1;
  var Q=String.fromCharCode(63);
  var DASH=String.fromCharCode(8722);
  var CHEV=String.fromCharCode(9662);
  var APROX=String.fromCharCode(8776);
  var IG='https://www.instagram.com/maiswimsuits/';
  var MAIL='hola@maibikinis.com';
  function digits(s){ var o=''; for(var i=0;i<s.length;i++){ var c=s.charAt(i); if(c>='0'&&c<='9'){ o+=c; } } return o; }

  /* ---- 1. links, IG y correo ---- */
  function fixLinks(){
    var b=document.querySelector('.maiQ__btn');
    if(b&&b.getAttribute('href')!=='/pages/contact'){ b.setAttribute('href','/pages/contact'); }
    [].forEach.call(document.querySelectorAll('a[href*="instagram.com"]'),function(a){
      if(a.getAttribute('href')!==IG){ a.setAttribute('href',IG); }
      var t=(a.textContent||'').trim();
      if(t.indexOf('@mai')===0&&t!=='@maiswimsuits'){ a.textContent='@maiswimsuits'; }
    });
    [].forEach.call(document.querySelectorAll('a[href^="mailto:"]'),function(a){
      if(a.getAttribute('href')!=='mailto:'+MAIL){ a.setAttribute('href','mailto:'+MAIL); }
      var t=(a.textContent||'').trim();
      if(t.indexOf('@')>0&&t!==MAIL){ a.textContent=MAIL; }
    });
  }
  function fixText(){
    var roots=[document.querySelector('main'),document.querySelector('footer')];
    for(var i=0;i<roots.length;i++){
      if(!roots[i]){ continue; }
      var w=document.createTreeWalker(roots[i],NodeFilter.SHOW_TEXT,null,false);
      var n,list=[];
      while((n=w.nextNode())){ if(n.nodeValue.indexOf('maiswimwear')>=0){ list.push(n); } }
      for(var k=0;k<list.length;k++){
        var v=list[k].nodeValue;
        v=v.split('hola@maiswimwear.com').join(MAIL);
        v=v.split('@maiswimwear.com').join('@maibikinis.com');
        v=v.split('maiswimwear.com').join('maibikinis.com');
        v=v.split('@maiswimwear').join('@maiswimsuits');
        list[k].nodeValue=v;
      }
    }
  }

  /* ---- 2. MAI GIRLS ---- */
  var MG={};
  function girls5(){
    var h=document.querySelector('.maiG__t');
    if(h&&h.textContent.trim()!=='MAI GIRLS'){ h.textContent='MAI GIRLS'; }
    var g=document.querySelector('.maiG__grid');
    if(!g){ return; }
    [].forEach.call(g.querySelectorAll('img'),function(im){
      if(im.getAttribute('data-mg5')){ return; }
      if(im.parentNode&&im.parentNode.tagName==='A'){ im.setAttribute('data-mg5','1'); return; }
      if(im.complete&&im.naturalWidth===0){ return; }
      im.setAttribute('data-mg5','1');
      var f=im.getAttribute('data-maiph')||'';
      var a=document.createElement('a');
      a.setAttribute('href',MG[f]||IG);
      a.setAttribute('target','_blank');
      a.setAttribute('rel','noopener');
      a.setAttribute('aria-label','Ver en Instagram');
      im.parentNode.insertBefore(a,im);
      a.appendChild(im);
      var s=document.createElement('span');
      s.className='maiGig';
      s.textContent='Ver en Instagram';
      a.appendChild(s);
    });
  }

  /* ---- 3. header hamburguesa + drawer acordeon ---- */
  var SECS=[
    ['Tienda',[['All','/collections/all','top-pipa'],['Tops','/collections/tops','top-saona'],['Bottoms','/collections/bottoms','bottom-pipa']],1],
    ['Colecciones',[['The Essentials','/collections/the-essentials','bottom-saona']],1],
    ['Nosotras',[['Historia','/pages/nosotras',''],['FAQs','/pages/preguntas-frecuentes',''],['MAI GIRLS','/pages/mai-girls',''],['Contáctanos','/pages/contact','']],0]
  ];
  var CURS=[['CLP','CLP $'],['USD','USD $'],['EUR','EUR '+String.fromCharCode(8364)],['COP','COP $']];
  var LANGS=[['es','ES'],['en','EN']];
  function hideNav(){
    var m=document.querySelector('header-menu.header-menu');
    if(m&&m.style.display!=='none'){ m.style.display='none'; }
    var d=document.querySelector('.header__drawer');
    if(d&&d.style.display!=='none'){ d.style.display='none'; }
  }
  function openDw(){ var d=document.getElementById('maiDw'); if(!d){ return; } d.classList.add('on'); document.body.classList.add('maiDwOpen'); }
  function closeDw(){ var d=document.getElementById('maiDw'); if(d){ d.classList.remove('on'); } document.body.classList.remove('maiDwOpen'); }
  function thumbs(){
    [].forEach.call(document.querySelectorAll('.maiDw__th[data-th]'),function(im){
      var h=im.getAttribute('data-th');
      im.removeAttribute('data-th');
      if(!h){ return; }
      fetch('/products/'+h+'.js').then(function(r){ return r.json(); }).then(function(p){
        if(p&&p.featured_image){ im.setAttribute('src',p.featured_image+(p.featured_image.indexOf(Q)<0?Q+'width=140':'')); }
      }).catch(function(){});
    });
  }
  function buildDw(){
    if(document.getElementById('maiDw')){ return; }
    if(!document.body){ return; }
    var nav='';
    for(var i=0;i<SECS.length;i++){
      var it=SECS[i][1], th=SECS[i][2], sub='';
      for(var j=0;j<it.length;j++){
        sub+='<a class="maiDw__lk" href="'+it[j][1]+'">'+(th?'<img class="maiDw__th" data-th="'+it[j][2]+'" alt="">':'')+'<span>'+it[j][0]+'</span></a>';
      }
      nav+='<button class="maiDw__row" type="button" data-acc="'+i+'">'+SECS[i][0]+'<span class="maiDw__pm">+</span></button><div class="maiDw__sub" data-sub="'+i+'">'+sub+'</div>';
    }
    var curOpt='';
    for(var c=0;c<CURS.length;c++){ curOpt+='<option value="'+CURS[c][0]+'">'+CURS[c][1]+'</option>'; }
    var lgOpt='';
    for(var l=0;l<LANGS.length;l++){ lgOpt+='<option value="'+LANGS[l][0]+'">'+LANGS[l][1]+'</option>'; }
    var logo='<span>MAI</span>';
    var hl=document.querySelector('.header-logo img');
    if(hl&&hl.getAttribute('src')){ logo='<img src="'+hl.getAttribute('src')+'" alt="MAI">'; }
    var d=document.createElement('div');
    d.className='maiDw'; d.id='maiDw';
    d.innerHTML='<div class="maiDw__dim"></div><div class="maiDw__panel">'
      +'<button class="maiDw__x" type="button" aria-label="Cerrar">'+String.fromCharCode(215)+'</button>'
      +'<div class="maiDw__head">'+logo+'</div>'
      +'<div class="maiDw__nav">'+nav+'</div>'
      +'<div class="maiDw__foot"><a href="/account">Mi cuenta</a><a href="/search">Buscar</a>'
      +'<div class="maiDw__sel"><select id="maiCur" aria-label="Moneda">'+curOpt+'</select><select id="maiLang" aria-label="Idioma">'+lgOpt+'</select></div>'
      +'<p class="maiDw__note" id="maiCurNote"></p>'
      +'<a class="maiDw__cta" href="/collections/all">Ver todo</a></div></div>';
    document.body.appendChild(d);
    d.querySelector('.maiDw__dim').addEventListener('click',closeDw);
    d.querySelector('.maiDw__x').addEventListener('click',closeDw);
    [].forEach.call(d.querySelectorAll('.maiDw__row'),function(r){
      r.addEventListener('click',function(){
        var k=r.getAttribute('data-acc');
        var s=d.querySelector('.maiDw__sub[data-sub="'+k+'"]');
        var on=s.classList.contains('on');
        [].forEach.call(d.querySelectorAll('.maiDw__sub'),function(x){ x.classList.remove('on'); });
        [].forEach.call(d.querySelectorAll('.maiDw__pm'),function(x){ x.textContent='+'; });
        if(!on){ s.classList.add('on'); r.querySelector('.maiDw__pm').textContent=DASH; }
      });
    });
    var cs=d.querySelector('#maiCur');
    cs.value=curNow();
    cs.addEventListener('change',function(){ setCur(cs.value); });
    var ls=d.querySelector('#maiLang');
    ls.value=langNow();
    ls.addEventListener('change',function(){ goLang(ls.value); });
    thumbs(); curNote();
  }
  function burger(){
    var left=document.querySelector('.header__column--left');
    if(!left||left.querySelector('.maiBg')){ return; }
    var b=document.createElement('button');
    b.className='maiBg'; b.type='button';
    b.setAttribute('aria-label','Menu');
    b.innerHTML='<i></i><i></i><i></i>';
    b.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); buildDw(); openDw(); });
    left.insertBefore(b,left.firstChild);
  }
  function hdrLoc(){
    var r=document.querySelector('.header__column--right');
    if(!r||r.querySelector('.maiHdr__loc')){ return; }
    var w=document.createElement('div');
    w.className='maiHdr__loc';
    w.innerHTML='<button type="button">'+langNow().toUpperCase()+' '+CHEV+'</button>';
    w.querySelector('button').addEventListener('click',function(e){
      e.preventDefault(); buildDw(); openDw();
      setTimeout(function(){ var s=document.getElementById('maiLang'); if(s){ try{ s.focus(); }catch(x){} } },350);
    });
    r.insertBefore(w,r.firstChild);
  }

  /* ---- idioma ---- */
  function langNow(){ return (window.Shopify&&Shopify.locale)||'es'; }
  function stripLang(p){ if(p==='/en'){ return '/'; } if(p.indexOf('/en/')===0){ return p.substring(3); } return p; }
  function goLang(v){ var p=stripLang(location.pathname); location.href=(v==='es'?'':'/en')+p+location.search; }

  /* ---- moneda (referencia) ---- */
  var RATES=null;
  var SYM={CLP:'$',USD:'US$',EUR:String.fromCharCode(8364),COP:'COP$'};
  function curNow(){ try{ return localStorage.getItem('maiCur')||'CLP'; }catch(e){ return 'CLP'; } }
  function setCur(v){ try{ localStorage.setItem('maiCur',v); }catch(e){} applyCur(); curNote(); }
  function fmt(n,cur){
    var d=(cur==='CLP'||cur==='COP')?0:2;
    var s=n.toFixed(d).split('.');
    var ip=s[0], out='', cnt=0;
    for(var i=ip.length-1;i>=0;i--){ out=ip.charAt(i)+out; cnt++; if(cnt%3===0&&i>0){ out='.'+out; } }
    if(s[1]){ out=out+','+s[1]; }
    return SYM[cur]+' '+out;
  }
  function applyCur(){
    var cur=curNow();
    [].forEach.call(document.querySelectorAll('.maiH__price,.maiPD__price'),function(e){
      var orig=e.getAttribute('data-orig');
      if(orig===null){
        orig=e.textContent;
        e.setAttribute('data-orig',orig);
        e.setAttribute('data-clp',digits(orig));
      }
      if(cur==='CLP'||!RATES||!RATES[cur]){ if(e.textContent!==orig){ e.textContent=orig; } return; }
      var v=parseFloat(e.getAttribute('data-clp'))||0;
      var t=APROX+' '+fmt(v*RATES[cur],cur);
      if(e.textContent!==t){ e.textContent=t; }
    });
  }
  function curNote(){
    var p=document.getElementById('maiCurNote');
    if(!p){ return; }
    var cur=curNow();
    if(cur==='CLP'){ p.textContent='Precios en pesos chilenos.'; }
    else if(RATES&&RATES[cur]){ p.textContent='Precio de referencia en '+cur+'. El cobro final se realiza en CLP.'; }
    else { p.textContent='No se pudo obtener el tipo de cambio. Se muestran los precios en CLP.'; }
  }
  function loadRates(){
    try{
      fetch('https://open.er-api.com/v6/latest/CLP').then(function(r){ return r.json(); }).then(function(j){
        if(j&&j.rates){ RATES=j.rates; applyCur(); curNote(); }
      }).catch(function(){});
    }catch(e){}
  }

  /* ---- orden + filtro coleccion en ALL ---- */
  var SORTS=[['rel','Relevancia'],['pasc','Precio: menor a mayor'],['pdesc','Precio: mayor a menor'],['az','Nombre: A-Z'],['za','Nombre: Z-A']];
  function cardPrice(c){
    var e=c.querySelector('.maiH__price');
    if(!e){ return 0; }
    return parseFloat(e.getAttribute('data-clp')||digits(e.textContent||''))||0;
  }
  function doSort(){
    var grid=document.getElementById('maiA2grid');
    var sel=document.getElementById('maiSort');
    if(!grid||!sel){ return; }
    var v=sel.value;
    var cards=[].slice.call(grid.querySelectorAll('.maiH__card'));
    for(var i=0;i<cards.length;i++){ if(!cards[i].getAttribute('data-ord')){ cards[i].setAttribute('data-ord',String(i)); } }
    cards.sort(function(a,b){
      if(v==='pasc'){ return cardPrice(a)-cardPrice(b); }
      if(v==='pdesc'){ return cardPrice(b)-cardPrice(a); }
      if(v==='az'||v==='za'){
        var na=((a.querySelector('.maiH__name')||{textContent:''}).textContent||'').trim().toLowerCase();
        var nb=((b.querySelector('.maiH__name')||{textContent:''}).textContent||'').trim().toLowerCase();
        if(na<nb){ return v==='az'?-1:1; }
        if(na>nb){ return v==='az'?1:-1; }
        return 0;
      }
      return parseInt(a.getAttribute('data-ord'),10)-parseInt(b.getAttribute('data-ord'),10);
    });
    for(var k=0;k<cards.length;k++){ grid.appendChild(cards[k]); }
  }
  function sortBar(){
    var bar=document.getElementById('maiA2bar');
    if(!bar||bar.getAttribute('data-s5')){ return; }
    var right=bar.querySelector('.maiA2__right');
    if(!right){ return; }
    bar.setAttribute('data-s5','1');
    var g=document.createElement('div');
    g.className='maiA2__grp';
    g.innerHTML='<span class="maiA2__lbl">Colección</span><button class="maiA2__chip on" type="button" data-coll="the-essentials">The Essentials</button>';
    bar.insertBefore(g,right);
    g.querySelector('[data-coll]').addEventListener('click',function(){ this.classList.toggle('on'); });
    var opt='';
    for(var i=0;i<SORTS.length;i++){ opt+='<option value="'+SORTS[i][0]+'">'+SORTS[i][1]+'</option>'; }
    var s=document.createElement('div');
    s.className='maiA2__sort';
    s.innerHTML='<span class="maiA2__lbl">Ordenar por</span><select id="maiSort">'+opt+'</select>';
    right.insertBefore(s,right.firstChild);
    document.getElementById('maiSort').addEventListener('change',doSort);
  }

  function all5(){
    try{ hideNav(); }catch(e){}
    try{ buildDw(); }catch(e){}
    try{ burger(); }catch(e){}
    try{ hdrLoc(); }catch(e){}
    try{ fixLinks(); }catch(e){}
    try{ fixText(); }catch(e){}
    try{ girls5(); }catch(e){}
    try{ sortBar(); }catch(e){}
    try{ applyCur(); }catch(e){}
  }
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ closeDw(); } });
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',all5); } else { all5(); }
  setInterval(all5,1800);
  loadRates();
})();


/* =========== MAI · v6: ajustes finos =========== */
(function(){
  if(window.__MAI8){ return; }
  window.__MAI8=1;
  try{
    var st=document.createElement('style');
    st.textContent='.maiG__grid>.maiPh{aspect-ratio:454/567;display:flex;align-items:center;justify-content:center}';
    if(document.head){ document.head.appendChild(st); }
  }catch(e){}
  var EN=null;
  function dropEn(){
    var s=document.getElementById('maiLang');
    if(!s){ return; }
    var kill=[];
    [].forEach.call(s.options,function(o){ if(o.value==='en'){ kill.push(o); } });
    for(var i=0;i<kill.length;i++){ if(kill[i].parentNode){ kill[i].parentNode.removeChild(kill[i]); } }
  }
  function chkEn(){
    try{
      fetch('/en/',{method:'HEAD'}).then(function(r){ EN=!!r.ok; if(!EN){ dropEn(); } }).catch(function(){ EN=false; dropEn(); });
    }catch(e){ EN=false; }
  }
  function fix6(){
    [].forEach.call(document.querySelectorAll('a[href="/pages/mai-girls"]'),function(a){
      if(a.children.length===0&&a.textContent.trim()!=='MAI GIRLS'){ a.textContent='MAI GIRLS'; }
    });
    if(EN===false){ dropEn(); }
  }
  chkEn();
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',fix6); } else { fix6(); }
  setInterval(fix6,2000);
})();


/* =========== MAI · v7 =========== */
(function(){
  if(window.__MAI9){ return; }
  window.__MAI9=1;
  try{
    var st=document.createElement('style');
    st.textContent='.maiG__grid .maiPh{aspect-ratio:454/567;display:flex;align-items:center;justify-content:center;width:100%}.maiG__grid a:has(.maiPh){pointer-events:none}';
    if(document.head){ document.head.appendChild(st); }
  }catch(e){}
})();


/* =========== MAI · v8: MAI GIRLS + UGC + monedas del mundo + idioma =========== */
(function(){
  if(window.__MAI10){ return; }
  window.__MAI10=1;
  try{ localStorage.setItem('maiCur','CLP'); }catch(e){}
  var Q=String.fromCharCode(63);
  var APROX=String.fromCharCode(8776);
  var F='/cdn/shop/files/';
  var IGP='https://www.instagram.com/p/';
  var GIRLS=[
    ['mai-girl-1.jpg',IGP+'DYPERmHjGvP/'],
    ['mai-girl-2.jpg',IGP+'DcrQ-yGFtU6/'],
    ['mai-girl-3.jpg',IGP+'DaOtsshDO7z/'],
    ['mai-girl-4.jpg',IGP+'DatKT2gjKdU/'],
    ['mai-girl-5.jpg',IGP+'DYu3WtKF4rt/']
  ];
  function digits(s){ var o=''; for(var i=0;i<s.length;i++){ var c=s.charAt(i); if(c>='0'&&c<='9'){ o+=c; } } return o; }
  function isEn(){ return (window.Shopify&&Shopify.locale)==='en'; }
  function lab(){ return isEn()?'View on Instagram':'Ver en Instagram'; }

  function card(f,link,alt){
    return '<a href="'+link+'" target="_blank" rel="noopener" aria-label="'+lab()+'">'
      +'<img src="'+F+f+Q+'width=1200" alt="'+alt+'" loading="lazy" data-maiph="'+f+'">'
      +'<span class="maiGig">'+lab()+'</span></a>';
  }
  function girls8(){
    var g=document.querySelector('.maiG__grid');
    if(!g||g.getAttribute('data-mg8')){ return; }
    g.setAttribute('data-mg8','1');
    var h='';
    for(var i=0;i<GIRLS.length;i++){ h+=card(GIRLS[i][0],GIRLS[i][1],'MAI girl '+(i+1)); }
    g.innerHTML=h;
  }
  function ugc8(){
    [].forEach.call(document.querySelectorAll('.maiUGC__grid'),function(gr){
      if(gr.getAttribute('data-ugc8')){ return; }
      gr.setAttribute('data-ugc8','1');
      var n=gr.children.length;
      if(!n||n>GIRLS.length){ n=4; }
      var h='';
      for(var i=0;i<n;i++){ h+=card(GIRLS[i][0],GIRLS[i][1],'MAI girl '+(i+1)); }
      gr.innerHTML=h;
    });
  }
  function thumb8(){
    var im=document.querySelector('.maiDw__sub[data-sub="1"] img.maiDw__th');
    if(!im||im.getAttribute('data-t8')){ return; }
    im.setAttribute('data-t8','1');
    im.setAttribute('src',F+'essentials-header-desktop.png'+Q+'width=180');
  }

  var CURS=['CLP','USD','EUR','COP','ARS','BRL','PEN','UYU','MXN','GBP','CAD','AUD','NZD','CHF','SEK','NOK','DKK','PLN','CZK','JPY','CNY','KRW','INR','SGD','HKD','THB','IDR','PHP','MYR','AED','SAR','ILS','ZAR','TRY','RUB','NGN','EGP','MAD','KES'];
  var ZERO={CLP:1,COP:1,JPY:1,KRW:1,PYG:1,VND:1,IDR:1,CLF:1};
  var RATES=null;
  function cur8(){ try{ return localStorage.getItem('maiCur8')||'CLP'; }catch(e){ return 'CLP'; } }
  function fmt(n,c){
    var d=ZERO[c]?0:2;
    var s=n.toFixed(d).split('.');
    var ip=s[0], out='', cnt=0;
    for(var i=ip.length-1;i>=0;i--){ out=ip.charAt(i)+out; cnt++; if(cnt%3===0&&i>0){ out='.'+out; } }
    if(s[1]){ out=out+','+s[1]; }
    return c+' '+out;
  }
  function apply8(){
    var c=cur8();
    [].forEach.call(document.querySelectorAll('.maiH__price,.maiPD__price,.maiS__price'),function(e){
      var o=e.getAttribute('data-o8');
      if(o===null){
        o=e.getAttribute('data-orig');
        if(o===null){ o=e.textContent; }
        e.setAttribute('data-o8',o);
        e.setAttribute('data-c8',digits(o));
      }
      var txt=o;
      if(c!=='CLP'&&RATES&&RATES[c]){
        txt=APROX+' '+fmt((parseFloat(e.getAttribute('data-c8'))||0)*RATES[c],c);
      }
      if(e.getAttribute('data-orig')!==txt){ e.setAttribute('data-orig',txt); }
      if(e.textContent!==txt){ e.textContent=txt; }
    });
    var p=document.getElementById('maiCurNote');
    if(p){
      if(c==='CLP'){ p.textContent=isEn()?'Prices in Chilean pesos.':'Precios en pesos chilenos.'; }
      else if(RATES&&RATES[c]){ p.textContent=isEn()?('Reference price in '+c+'. Checkout is charged in CLP.'):('Precio de referencia en '+c+'. El cobro final se realiza en CLP.'); }
      else { p.textContent=isEn()?'Exchange rate unavailable. Showing CLP.':'No se pudo obtener el tipo de cambio. Se muestran los precios en CLP.'; }
    }
  }
  function setCur8(v){
    try{ localStorage.setItem('maiCur8',v); localStorage.setItem('maiCur','CLP'); }catch(e){}
    [].forEach.call(document.querySelectorAll('.maiCurSel'),function(s){ s.value=v; });
    apply8();
  }
  function buildCurSel(){
    var s=document.createElement('select');
    s.className='maiCurSel';
    s.setAttribute('aria-label','Moneda');
    var h='';
    for(var i=0;i<CURS.length;i++){ h+='<option value="'+CURS[i]+'">'+CURS[i]+(CURS[i]==='CLP'?' $':'')+'</option>'; }
    s.innerHTML=h;
    s.value=cur8();
    s.addEventListener('change',function(){ setCur8(s.value); });
    return s;
  }
  function curUI(){
    var old=document.getElementById('maiCur');
    if(old&&old.parentNode){
      var ns=buildCurSel();
      ns.id='maiCurDw';
      old.parentNode.replaceChild(ns,old);
    }
    var r=document.querySelector('.header__column--right');
    if(r&&!r.querySelector('.maiHdr__cur')){
      var w=document.createElement('div');
      w.className='maiHdr__cur';
      w.appendChild(buildCurSel());
      r.insertBefore(w,r.firstChild);
    }
  }
  function loadRates8(){
    try{
      fetch('https://open.er-api.com/v6/latest/CLP').then(function(r){ return r.json(); }).then(function(j){
        if(j&&j.rates){ RATES=j.rates; apply8(); }
      }).catch(function(){});
    }catch(e){}
  }
  function langUI(){
    [].forEach.call(document.querySelectorAll('.localization-form__select'),function(s){
      if(s.getAttribute('data-l8')){ return; }
      if(s.name&&s.name.indexOf('locale')<0){ return; }
      s.setAttribute('data-l8','1');
      [].forEach.call(s.options,function(o){
        var v=(o.value||'').toLowerCase();
        if(v==='es'){ o.textContent='ES'; }
        else if(v==='en'){ o.textContent='EN'; }
      });
    });
  }
  var T={
    'Tienda':'Shop','Colecciones':'Collections','Nosotras':'About us',
    'Historia':'Our story','Contáctanos':'Contact us','Contacto':'Contact',
    'Mi cuenta':'My account','Buscar':'Search','Carrito':'Cart','Ver todo':'Shop all',
    'Búsquedas populares':'Popular searches','Productos sugeridos':'Suggested products',
    'Nuevos':'New in',
    'MODELO':'MODEL','TIPO':'TYPE','TALLA':'SIZE','COLECCIÓN':'COLLECTION','ORDENAR POR':'SORT BY',
    'Modelo':'Model','Tipo':'Type','Talla':'Size','Colección':'Collection','Ordenar por':'Sort by',
    'Relevancia':'Relevance','Precio: menor a mayor':'Price: low to high','Precio: mayor a menor':'Price: high to low',
    'Nombre: A-Z':'Name: A-Z','Nombre: Z-A':'Name: Z-A','Limpiar':'Clear',
    'No hay productos con esos filtros.':'No products match those filters.',
    'Rojo':'Red','Celeste':'Light blue','Amarillo':'Yellow','Perla':'Pearl',
    'Guía de tallas':'Size guide','Guía de cuidados':'Care guide',
    'Busto (cm)':'Bust (cm)','Bajo busto (cm)':'Underbust (cm)','Copa':'Cup',
    'Cintura (cm)':'Waist (cm)','Cadera (cm)':'Hip (cm)',
    'Medidas en centímetros. Si estás entre dos tallas, te recomendamos elegir la mayor.':'Measurements in centimetres. If you are between two sizes, we recommend going up.',
    'Ver en Instagram':'View on Instagram',
    'NOSOTRAS':'ABOUT US','COLECCIONES':'COLLECTIONS','AYUDA':'HELP','SEGURIDAD Y POLÍTICAS':'SECURITY & POLICIES',
    'Términos y condiciones':'Terms & conditions','Política de privacidad':'Privacy policy',
    'Política de envíos':'Shipping policy','Cambios y devoluciones':'Returns & exchanges',
    'Política de garantía':'Warranty policy','Aviso legal':'Legal notice',
    'Ofertas exclusivas y acceso anticipado a lo nuevo.':'Exclusive offers and early access to new drops.',
    'MAI en ustedes <3':'MAI on you <3',
    'Te puede gustar':'You may also like','Información de contacto':'Contact information',
    'Nombre completo':'Full name','Asunto':'Subject','Mensaje':'Message','Enviar mensaje':'Send message',
    'Preguntas frecuentes':'FAQs'
  };
  function tr8(){
    if(!isEn()||!document.body){ return; }
    var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null,false);
    var n,list=[];
    while((n=w.nextNode())){
      var k=n.nodeValue.trim();
      if(k&&T[k]&&T[k]!==k){ list.push([n,k]); }
    }
    for(var i=0;i<list.length;i++){
      list[i][0].nodeValue=list[i][0].nodeValue.replace(list[i][1],T[list[i][1]]);
    }
    [].forEach.call(document.querySelectorAll('.maiA2__count'),function(e){
      var t=e.textContent;
      if(t.indexOf('productos')>0){ e.textContent=t.replace('productos','products'); }
    });
    [].forEach.call(document.querySelectorAll('input[placeholder]'),function(e){
      if(e.getAttribute('placeholder')==='Buscar productos...'){ e.setAttribute('placeholder','Search products...'); }
    });
  }
  function all8(){
    try{ girls8(); }catch(e){}
    try{ ugc8(); }catch(e){}
    try{ thumb8(); }catch(e){}
    try{ curUI(); }catch(e){}
    try{ apply8(); }catch(e){}
    try{ langUI(); }catch(e){}
    try{ tr8(); }catch(e){}
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',all8); } else { all8(); }
  setInterval(all8,1800);
  loadRates8();
})();


/* =========== MAI · v9: etiquetas ES / EN del selector de idioma =========== */
(function(){
  if(window.__MAI11){ return; }
  window.__MAI11=1;
  var M={es:'ES',en:'EN','es-cl':'ES','en-us':'EN'};
  function lang9(){
    [].forEach.call(document.querySelectorAll('select.localization-form__select'),function(s){
      var nm=(s.getAttribute('name')||'').toLowerCase();
      if(nm.indexOf('lang')<0&&nm.indexOf('locale')<0){ return; }
      [].forEach.call(s.options,function(o){
        var k=(o.value||'').toLowerCase();
        if(M[k]&&o.textContent.trim()!==M[k]){ o.textContent=M[k]; }
      });
    });
  }
  function run9(){ try{ lang9(); }catch(e){} }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run9); } else { run9(); }
  setInterval(run9,1800);
})();


/* =========== MAI · v11: links de IG por foto (a prueba de fixLinks) =========== */
(function(){
  if(window.__MAI12){ return; }
  window.__MAI12=1;
  var Q=String.fromCharCode(63);
  var F='/cdn/shop/files/';
  var P='https://www.instagram.com/p/';
  var G=[
    ['mai-girl-1.jpg',P+'DYPERmHjGvP/'],
    ['mai-girl-2.jpg',P+'DcrQ-yGFtU6/'],
    ['mai-girl-3.jpg',P+'DaOtsshDO7z/'],
    ['mai-girl-4.jpg',P+'DatKT2gjKdU/'],
    ['mai-girl-5.jpg',P+'DYu3WtKF4rt/']
  ];
  function isEn(){ return (window.Shopify&&Shopify.locale)==='en'; }
  function lab(){ return isEn()?'View on Instagram':'Ver en Instagram'; }
  function card(i){
    return '<a href="#" data-ig="'+G[i][1]+'" aria-label="'+lab()+'">'
      +'<img src="'+F+G[i][0]+Q+'width=1200" alt="MAI girl '+(i+1)+'" loading="lazy" data-maiph="'+G[i][0]+'">'
      +'<span class="maiGig">'+lab()+'</span></a>';
  }
  function fill(sel,n){
    [].forEach.call(document.querySelectorAll(sel),function(gr){
      if(gr.getAttribute('data-v11')){ return; }
      gr.setAttribute('data-v11','1');
      var k=n||gr.children.length;
      if(!k||k>G.length){ k=G.length; }
      var h='';
      for(var i=0;i<k;i++){ h+=card(i); }
      gr.innerHTML=h;
    });
  }
  document.addEventListener('click',function(e){
    var t=e.target;
    while(t&&t!==document.body){
      if(t.getAttribute&&t.getAttribute('data-ig')){
        e.preventDefault();
        window.open(t.getAttribute('data-ig'),'_blank','noopener');
        return;
      }
      t=t.parentNode;
    }
  },true);
  function run11(){
    try{ fill('.maiG__grid',G.length); }catch(e){}
    try{ fill('.maiUGC__grid',0); }catch(e){}
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run11); } else { run11(); }
  setInterval(run11,1500);
})();


/* =========== MAI · v12: miniatura fija de The Essentials =========== */
(function(){
  if(window.__MAI13){ return; }
  window.__MAI13=1;
  var SRC='/cdn/shop/files/essentials-header-desktop.png'+String.fromCharCode(63)+'width=200';
  function fix12(){
    var im=document.querySelector('.maiDw__sub[data-sub="1"] img.maiDw__th');
    if(!im){ return; }
    var s=im.getAttribute('src')||'';
    if(s.indexOf('essentials-hero')<0){ im.removeAttribute('data-th'); im.setAttribute('src',SRC); }
  }
  function run12(){ try{ fix12(); }catch(e){} }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run12); } else { run12(); }
  setInterval(run12,1200);
})();

/* =========== MAI · v13: reemplaza la foto gris del Saona Wine =========== */
(function(){
  if(window.__MAI14){ return; }
  window.__MAI14=1;
  var Q=String.fromCharCode(63);
  var BAD='ChatGPTImage3ago2026_17_51_38';
  var GOOD='/cdn/shop/files/TOP_SAONA_VINO_TINTO.png';
  function wOf(u){
    var i=u.indexOf('width=');
    if(i<0){ return '1200'; }
    var s=u.substring(i+6), o='';
    for(var k=0;k<s.length;k++){ var c=s.charAt(k); if(c>='0'&&c<='9'){ o+=c; } else { break; } }
    return o||'1200';
  }
  var ATTRS=['src','data-img','data-src','href'];
  function fix13(){
    [].forEach.call(document.querySelectorAll('img,source,a,span,div'),function(e){
      for(var i=0;i<ATTRS.length;i++){
        var v=e.getAttribute(ATTRS[i]);
        if(v&&v.indexOf(BAD)>=0){ e.setAttribute(ATTRS[i],GOOD+Q+'width='+wOf(v)); }
      }
      var ss=e.getAttribute('srcset');
      if(ss&&ss.indexOf(BAD)>=0){ e.removeAttribute('srcset'); }
    });
  }
  function run13(){ try{ fix13(); }catch(e){} }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run13); } else { run13(); }
  setInterval(run13,1200);
})();

/* =========== MAI · v14: colores de swatch en /en/ =========== */
(function(){
  if(window.__MAI15){ return; }
  window.__MAI15=1;
  var HEX={'Rojo':'#d1252a','Celeste':'#68c7e6','Amarillo':'#f4cf3f','Wine':'#6e1f2e','Perla':'#ece5da','Caramel':'#a76a37'};
  function fix14(){
    var box=document.querySelector('.maiSwatches');
    if(!box){ return; }
    var ins=box.querySelectorAll('input');
    var lbs=box.querySelectorAll('.variant-option__button-label');
    for(var i=0;i<lbs.length&&i<ins.length;i++){
      var v=(ins[i].value||'').trim();
      var h=HEX[v];
      if(!h){ continue; }
      var cur=getComputedStyle(lbs[i]).backgroundColor;
      if(cur==='rgb(204, 204, 204)'||cur==='rgba(0, 0, 0, 0)'){ lbs[i].style.background=h; }
    }
  }
  function run14(){ try{ fix14(); }catch(e){} }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run14); } else { run14(); }
  setInterval(run14,1200);
})();


/* =========== MAI · v15: swatch !important + mas textos en ingles =========== */
(function(){
  if(window.__MAI16){ return; }
  window.__MAI16=1;
  var HEX={'Rojo':'#d1252a','Celeste':'#68c7e6','Amarillo':'#f4cf3f','Wine':'#6e1f2e','Perla':'#ece5da','Caramel':'#a76a37'};
  function sw15(){
    var box=document.querySelector('.maiSwatches');
    if(!box){ return; }
    var ins=box.querySelectorAll('input');
    var lbs=box.querySelectorAll('.variant-option__button-label');
    for(var i=0;i<lbs.length&&i<ins.length;i++){
      var h=HEX[(ins[i].value||'').trim()];
      if(!h){ continue; }
      if(lbs[i].getAttribute('data-sw15')===h){ continue; }
      lbs[i].style.setProperty('background-color',h,'important');
      lbs[i].style.setProperty('background-image','none','important');
      lbs[i].setAttribute('data-sw15',h);
    }
  }
  var S={
    'Bienvenido a nuestra tienda':'Welcome to our store',
    'Producto hecho éticamente por mujeres':'Ethically made by women',
    'Hechos en Colombia':'Made in Colombia',
    'Guía de tallas':'Size guide',
    'COMPRAR AHORA':'BUY IT NOW',
    'Agregar al carrito':'Add to cart',
    'AGOTADO':'SOLD OUT',
    ' · Rojo':' · Red',
    ' · Celeste':' · Light blue',
    ' · Amarillo':' · Yellow',
    ' · Perla':' · Pearl'
  };
  var KEYS=[];
  for(var k in S){ if(S.hasOwnProperty(k)){ KEYS.push(k); } }
  function tr15(){
    if((window.Shopify&&Shopify.locale)!=='en'||!document.body){ return; }
    var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null,false);
    var n,list=[];
    while((n=w.nextNode())){
      var v=n.nodeValue;
      if(!v||v.length>140){ continue; }
      for(var i=0;i<KEYS.length;i++){ if(v.indexOf(KEYS[i])>=0){ list.push(n); break; } }
    }
    for(var j=0;j<list.length;j++){
      var t2=list[j].nodeValue;
      for(var m=0;m<KEYS.length;m++){ t2=t2.split(KEYS[m]).join(S[KEYS[m]]); }
      list[j].nodeValue=t2;
    }
  }
  function run15(){ try{ sw15(); }catch(e){} try{ tr15(); }catch(e){} }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run15); } else { run15(); }
  setInterval(run15,1200);
})();


/* =========== MAI · v16: mantiene el color del swatch en /en/ =========== */
(function(){
  if(window.__MAI17){ return; }
  window.__MAI17=1;
  var HEX={'Rojo':'#d1252a','Celeste':'#68c7e6','Amarillo':'#f4cf3f','Wine':'#6e1f2e','Perla':'#ece5da','Caramel':'#a76a37'};
  function go16(){
    var box=document.querySelector('.maiSwatches');
    if(!box){ return; }
    var ins=box.querySelectorAll('input');
    var lbs=box.querySelectorAll('.variant-option__button-label');
    for(var i=0;i<lbs.length&&i<ins.length;i++){
      var h=HEX[(ins[i].value||'').trim()];
      if(!h){ continue; }
      if(getComputedStyle(lbs[i]).backgroundColor!=='rgb(204, 204, 204)'){ continue; }
      lbs[i].style.setProperty('background',h,'important');
    }
  }
  function run16(){ try{ go16(); }catch(e){} }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run16); } else { run16(); }
  setInterval(run16,400);
})();


/* =========== MAI · v18: MAI GIRLS con 8 fotos y su link de IG =========== */
(function(){
  if(window.__MAI18){ return; }
  window.__MAI18=1;
  var Q=String.fromCharCode(63);
  var F='/cdn/shop/files/';
  var P='https://www.instagram.com/p/';
  var PERFIL='https://www.instagram.com/maiswimsuits/';
  var G=[
    ['mai-girl-1.jpg',P+'DYPERmHjGvP/'],
    ['mai-girl-2.jpg',P+'DcrQ-yGFtU6/'],
    ['mai-girl-3.jpg',P+'DYu3WtKF4rt/'],
    ['mai-girl-4.jpg',P+'DatKT2gjKdU/'],
    ['mai-girl-5.jpg',P+'DaOtsshDO7z/'],
    ['mai-girl-6.jpg',PERFIL],
    ['mai-girl-7.jpg',PERFIL],
    ['mai-girl-8.jpg',PERFIL]
  ];
  function isEn(){ return (window.Shopify&&Shopify.locale)==='en'; }
  function lab(){ return isEn()?'View on Instagram':'Ver en Instagram'; }
  function card(i){
    return '<a href="#" data-ig="'+G[i][1]+'" aria-label="'+lab()+'">'
      +'<img src="'+F+G[i][0]+Q+'width=1200" alt="MAI girl '+(i+1)+'" loading="lazy" data-maiph="'+G[i][0]+'">'
      +'<span class="maiGig">'+lab()+'</span></a>';
  }
  function fill18(sel,n){
    [].forEach.call(document.querySelectorAll(sel),function(gr){
      if(gr.getAttribute('data-v18')){ return; }
      gr.setAttribute('data-v18','1');
      var h='';
      for(var i=0;i<n;i++){ h+=card(i); }
      gr.innerHTML=h;
    });
  }
  function run18(){
    try{ fill18('.maiG__grid',G.length); }catch(e){}
    try{ fill18('.maiUGC__grid',4); }catch(e){}
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run18); } else { run18(); }
  setInterval(run18,1500);
})();


/* =========== MAI · v19: "Ya confian en MAI" (home + ALL) =========== */
(function(){
  if(window.__MAI19){ return; }
  window.__MAI19=1;
  var Q=String.fromCharCode(63);
  var HEART=String.fromCharCode(9825);
  var F='/cdn/shop/files/';
  var P='https://www.instagram.com/p/';
  var IG='https://www.instagram.com/maiswimsuits/';
  var S4=[
    ['mai-girl-1.jpg',P+'DYPERmHjGvP/'],
    ['mai-girl-2.jpg',P+'DcrQ-yGFtU6/'],
    ['mai-girl-3.jpg',P+'DYu3WtKF4rt/'],
    ['mai-girl-7.jpg',IG]
  ];
  function isEn(){ return (window.Shopify&&Shopify.locale)==='en'; }
  function lab(){ return isEn()?'View on Instagram':'Ver en Instagram'; }
  function card(i,w){
    return '<a href="#" data-ig="'+S4[i][1]+'" aria-label="'+lab()+'">'
      +'<img src="'+F+S4[i][0]+Q+'width='+(w||700)+'" alt="MAI girl" loading="lazy" data-maiph="'+S4[i][0]+'"></a>';
  }
  function uma(){
    var g=document.querySelector('.uma__grid');
    if(!g){ return; }
    var cells=g.querySelectorAll('.cell');
    if(!cells.length){ return; }
    for(var i=0;i<cells.length&&i<S4.length;i++){
      if(cells[i].getAttribute('data-v19')){ continue; }
      cells[i].setAttribute('data-v19','1');
      cells[i].innerHTML=card(i,700);
    }
  }
  function build(){
    if(location.pathname.indexOf('/collections/all')<0){ return; }
    if(document.querySelector('.uma')){ return; }
    var ban=document.querySelector('.maiCban');
    if(!ban||!ban.parentNode){ return; }
    var d=document.createElement('div');
    d.className='uma';
    var cells='';
    for(var i=0;i<S4.length;i++){ cells+='<div class="cell">'+card(i,700)+'</div>'; }
    d.innerHTML='<h2 class="uma__h">'+(isEn()?'They already trust MAI ':'Ya confían en MAI ')+HEART+'</h2>'
      +'<div class="uma__grid">'+cells+'</div>'
      +'<a class="uma__cta" href="'+IG+'" target="_blank" rel="noopener">'+(isEn()?'Follow us on Instagram @maiswimsuits':'Síguenos en Instagram @maiswimsuits')+'</a>';
    if(ban.nextSibling){ ban.parentNode.insertBefore(d,ban.nextSibling); } else { ban.parentNode.appendChild(d); }
  }
  function ugc(){
    [].forEach.call(document.querySelectorAll('.maiUGC__grid'),function(gr){
      if(gr.getAttribute('data-v19u')){ return; }
      gr.setAttribute('data-v19u','1');
      var h='';
      for(var i=0;i<S4.length;i++){ h+=card(i,900); }
      gr.innerHTML=h;
    });
  }
  function run19(){ try{ uma(); }catch(e){} try{ build(); }catch(e){} try{ ugc(); }catch(e){} }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run19); } else { run19(); }
  setInterval(run19,1500);
})();


/* =========== MAI · v21: Nosotras (fotos y videos reales + aparicion) =========== */
(function(){
  if(window.__MAI21){ return; }
  window.__MAI21=1;
  var Q=String.fromCharCode(63);
  var F='/cdn/shop/files/';
  var V='https://cdn.shopify.com/videos/c/o/v/';
  var P1=V+'37a993f504d4457492f6936bbc6e6ff2.mp4';
  var P2=V+'c9629a47894d4dfcb6e54ebdd55152ef.mp4';
  var MB=V+'22936169093249c8b0051271503ebe4f.mp4';
  function isN(){ return location.pathname.indexOf('/pages/nosotras')>=0; }
  function mkVideo(src,cls){
    var v=document.createElement('video');
    if(cls){ v.className=cls; }
    v.setAttribute('src',src);
    v.setAttribute('muted','');
    v.setAttribute('loop','');
    v.setAttribute('playsinline','');
    v.setAttribute('autoplay','');
    v.setAttribute('preload','metadata');
    v.muted=true; v.loop=true; v.playsInline=true; v.autoplay=true;
    return v;
  }
  function swap(el,node){
    if(!el||!el.parentNode){ return null; }
    el.parentNode.replaceChild(node,el);
    return node;
  }
  function heroFix(){
    var h=document.querySelector('.maiN__heroimg');
    if(!h||h.tagName==='PICTURE'||(h.parentNode&&h.parentNode.tagName==='PICTURE')){ return; }
    var pic=document.createElement('picture');
    pic.className='maiN__heropic';
    pic.innerHTML='<source media="(max-width:749px)" srcset="'+F+'nosotras-hero-mobile.jpg'+Q+'width=1200">'
      +'<img class="maiN__heroimg" src="'+F+'nosotras-hero.jpg'+Q+'width=1900" alt="Nosotras">';
    swap(h,pic);
  }
  function hotFix(){
    [].forEach.call(document.querySelectorAll('[data-maiph]'),function(el){
      var f=el.getAttribute('data-maiph');
      if(f!=='to-be-hot-1.jpg'&&f!=='to-be-hot-2.jpg'){ return; }
      var n=(f==='to-be-hot-1.jpg')?'tobehot-1.jpg':'tobehot-2.jpg';
      var im=document.createElement('img');
      im.className=el.className.split('maiPh').join('').replace('  ',' ').trim();
      im.setAttribute('src',F+n+Q+'width=1200');
      im.setAttribute('alt','TO BE HOT');
      im.setAttribute('loading','lazy');
      swap(el,im);
    });
  }
  function videoFix(){
    var pair=document.querySelector('.maiN__pair');
    if(pair&&!pair.getAttribute('data-v21')){
      pair.setAttribute('data-v21','1');
      var k=[].slice.call(pair.children);
      if(k[0]){ swap(k[0],mkVideo(P1)); }
      if(k[1]){ swap(k[1],mkVideo(P2)); }
    }
    var sq=document.querySelector('.maiN__sq');
    if(sq&&sq.tagName!=='VIDEO'){ swap(sq,mkVideo(MB,'maiN__sq')); }
    [].forEach.call(document.querySelectorAll('.maiN__pair video, video.maiN__sq'),function(v){
      if(v.paused){ var p=v.play(); if(p&&p.catch){ p.catch(function(){}); } }
    });
  }
  var io=null, nrev=0;
  function reveal(){
    var sel='.maiN__f, .maiN__strip img, .maiN__eye, .maiN__lead, .maiN__pair video, video.maiN__sq, .maiN__hotSide, .maiN__hotT';
    var els=document.querySelectorAll(sel);
    if(!els.length){ return; }
    if(!io){
      io=new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('on'); io.unobserve(e.target); } });
      },{rootMargin:'0px 0px -10% 0px',threshold:0.06});
    }
    [].forEach.call(els,function(el){
      if(el.getAttribute('data-rev')){ return; }
      el.setAttribute('data-rev','1');
      el.classList.add('maiRev');
      el.style.transitionDelay=(Math.min(nrev,7)*90)+'ms';
      nrev++;
      io.observe(el);
    });
  }
  function run21(){
    if(!isN()){ return; }
    try{ heroFix(); }catch(e){}
    try{ hotFix(); }catch(e){}
    try{ videoFix(); }catch(e){}
    try{ reveal(); }catch(e){}
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run21); } else { run21(); }
  setInterval(run21,1200);
})();


/* =========== MAI · v22: Nosotras — aire, diagramacion y parallax =========== */
(function(){
  if(window.__MAI22){ return; }
  window.__MAI22=1;
  var Q=String.fromCharCode(63);
  var F='/cdn/shop/files/';
  function isN(){ return location.pathname.indexOf('/pages/nosotras')>=0; }
  var CSS=[
    '.maiN__hero{padding-top:clamp(52px,7vw,86px)!important}',
    '.maiN__nace{padding-top:clamp(120px,16vw,250px)!important;padding-bottom:clamp(120px,16vw,250px)!important}',
    '.maiN__f{transition:opacity .6s ease;will-change:transform,opacity}',
    '.maiN__why{padding-top:clamp(110px,14vw,210px)!important;padding-bottom:clamp(110px,14vw,210px)!important;gap:clamp(40px,7vw,110px)!important}',
    '.maiN__more{padding-top:clamp(90px,12vw,180px)!important;padding-bottom:clamp(90px,12vw,180px)!important;gap:clamp(40px,7vw,110px)!important}',
    '.maiN__more .maiN__h2{max-width:9ch}',
    '.maiN__more .maiN__p+.maiN__p{margin-top:1.1em}',
    '.maiN__pair video{object-position:center 62%}',
    'video.maiN__sq{aspect-ratio:3/4!important;object-position:center 66%!important}',
    '.maiN__hot{padding-top:clamp(110px,15vw,220px)!important;padding-bottom:clamp(110px,15vw,220px)!important}',
    '.maiN__hotSide{width:clamp(170px,26vw,380px)!important;height:auto!important;aspect-ratio:405/733;object-fit:cover}',
    '.maiN__hotL{left:-1.5%!important;right:auto!important;top:0!important}',
    '.maiN__hotR{right:-1.5%!important;left:auto!important;top:0!important}',
    '.maiN__hotT{margin-bottom:clamp(34px,5vw,64px)!important}',
    '.maiN__hotIn{max-width:790px!important;margin-left:auto!important;margin-right:auto!important;gap:clamp(26px,4vw,52px)!important}',
    '@media(max-width:900px){.maiN__hotSide{width:34vw!important;opacity:.9}.maiN__hotIn{max-width:none!important;grid-template-columns:1fr!important}}'
  ].join('');
  function style(){
    if(document.getElementById('maiN22')||!document.head){ return; }
    var s=document.createElement('style');
    s.id='maiN22';
    s.textContent=CSS;
    document.head.appendChild(s);
  }
  function naceImgs(){
    [].forEach.call(document.querySelectorAll('[data-maiph]'),function(el){
      var f=el.getAttribute('data-maiph')||'';
      if(f.indexOf('nace-')!==0||f.indexOf('nace-0')===0){ return; }
      var n=f.charAt(5);
      if(n<'1'||n>'5'){ return; }
      var nf='nace-0'+n+'.jpg';
      el.setAttribute('data-maiph',nf);
      if(el.tagName==='IMG'){ el.setAttribute('src',F+nf+Q+'width=900'); }
    });
  }
  function moreText(){
    var sec=document.querySelector('.maiN__more');
    if(!sec||sec.getAttribute('data-v22')){ return; }
    var p=sec.querySelector('.maiN__p');
    if(!p){ return; }
    sec.setAttribute('data-v22','1');
    var t=p.textContent||'';
    var k=t.indexOf('Nuestros bikinis');
    if(k>0){
      var p2=document.createElement('p');
      p2.className=p.className;
      p2.textContent=t.slice(k).trim();
      p.textContent=t.slice(0,k).trim();
      if(p.nextSibling){ p.parentNode.insertBefore(p2,p.nextSibling); } else { p.parentNode.appendChild(p2); }
    }
    var h=sec.querySelector('.maiN__h2');
    if(h&&h.innerHTML.indexOf('<br')<0){
      h.innerHTML=(h.textContent||'').split('que un').join('que<br>un');
    }
  }
  var raf=0;
  function px(){
    raf=0;
    var sec=document.querySelector('.maiN__nace');
    if(!sec){ return; }
    var r=sec.getBoundingClientRect();
    var vh=window.innerHeight||800;
    var prog=(vh-r.top)/(vh+r.height);
    if(prog<0){ prog=0; }
    if(prog>1){ prog=1; }
    var sp=[80,130,60,150,100];
    [].forEach.call(document.querySelectorAll('.maiN__f'),function(el,i){
      var d=(prog-0.5)*2*sp[i%5];
      el.style.transform='translateY('+(-d).toFixed(1)+'px)';
      var o=(prog-0.05)*3.2;
      if(o<0){ o=0; }
      if(o>1){ o=1; }
      el.style.opacity=o.toFixed(2);
    });
  }
  function onScroll(){ if(!raf){ raf=requestAnimationFrame(px); } }
  function unrev(){
    [].forEach.call(document.querySelectorAll('.maiN__f'),function(el){
      if(el.classList.contains('maiRev')){
        el.classList.remove('maiRev');
        el.classList.remove('on');
        el.style.transitionDelay='';
      }
    });
  }
  var bound=false;
  function run22(){
    if(!isN()){ return; }
    try{ style(); }catch(e){}
    try{ naceImgs(); }catch(e){}
    try{ moreText(); }catch(e){}
    try{ unrev(); }catch(e){}
    if(!bound){
      bound=true;
      window.addEventListener('scroll',onScroll,{passive:true});
      window.addEventListener('resize',onScroll);
    }
    try{ px(); }catch(e){}
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run22); } else { run22(); }
  setInterval(run22,1200);
})();


/* =========== MAI · v23: Nosotras — hero mobile, parallax real, diagramacion =========== */
(function(){
  if(window.__MAI23){ return; }
  window.__MAI23=1;
  var Q=String.fromCharCode(63);
  var F='/cdn/shop/files/';
  function isN(){ return location.pathname.indexOf('/pages/nosotras')>=0; }
  var CSS=[
    '.maiN__hero{padding-top:clamp(74px,9vw,124px)!important}',
    '@media(max-width:900px){.maiHdr__cur{display:none!important}}',
    '.maiN__f{border-radius:14px;overflow:hidden;z-index:0}',
    '.maiN__naceIn{position:relative;z-index:3}',
    '.maiN__f1{left:1.5%!important;right:auto!important}',
    '.maiN__f2{left:-1%!important;right:auto!important}',
    '.maiN__f4{left:7%!important;right:auto!important}',
    '.maiN__f3{right:1.5%!important;left:auto!important}',
    '.maiN__f5{right:5%!important;left:auto!important}',
    '.maiN__why{align-items:end!important}',
    '.maiN__hotIn{max-width:min(620px,44vw)!important}',
    '.maiN__hot .maiN__p{line-height:1.45!important}',
    '.maiN__hot .maiN__h3{margin-bottom:.5em!important}',
    '@media(max-width:900px){.maiN__f{display:none!important}.maiN__hotIn{max-width:none!important}}'
  ].join('');
  function style(){
    if(document.getElementById('maiN23')||!document.head){ return; }
    var s=document.createElement('style');
    s.id='maiN23';
    s.textContent=CSS;
    document.head.appendChild(s);
  }
  function heroSrc(){
    var im=document.querySelector('.maiN__heroimg');
    if(!im||im.tagName!=='IMG'){ return; }
    var mob=(window.innerWidth||1200)<900;
    var want=F+(mob?'nosotras-hero-mobile.jpg':'nosotras-hero.jpg')+Q+'width='+(mob?1200:1900);
    if((im.getAttribute('src')||'')!==want){ im.setAttribute('src',want); }
  }
  var raf=0;
  function px2(){
    raf=0;
    var vh=window.innerHeight||800;
    var sp=[90,140,70,160,110];
    [].forEach.call(document.querySelectorAll('.maiN__f'),function(el,i){
      var r=el.getBoundingClientRect();
      var p=(vh-r.top)/(vh+r.height);
      if(p<0){ p=0; }
      if(p>1){ p=1; }
      var o=(p-0.04)*4;
      if(o<0){ o=0; }
      if(o>1){ o=1; }
      el.style.opacity=o.toFixed(2);
      el.style.transform='translateY('+((0.5-p)*sp[i%5]).toFixed(1)+'px)';
    });
  }
  function onScroll(){ if(!raf){ raf=requestAnimationFrame(px2); } }
  var bound=false;
  function run23(){
    if(!isN()){ return; }
    try{ style(); }catch(e){}
    try{ heroSrc(); }catch(e){}
    if(!bound){
      bound=true;
      window.addEventListener('scroll',onScroll,{passive:true});
      window.addEventListener('resize',onScroll);
    }
    try{ px2(); }catch(e){}
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run23); } else { run23(); }
  setInterval(run23,900);
})();


/* =========== MAI · v24: header en mobile =========== */
(function(){
  if(window.__MAI24){ return; }
  window.__MAI24=1;
  function go(){
    if(document.getElementById('mai24')||!document.head){ return; }
    var s=document.createElement('style');
    s.id='mai24';
    s.textContent='@media(max-width:900px){.dropdown-localization{display:none!important}.maiHdr__cur{display:none!important}.maiHdr__loc{display:none!important}}';
    document.head.appendChild(s);
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',go); } else { go(); }
  setInterval(go,2000);
})();


/* =========== MAI · v25: Nosotras — hero sin header encima, animacion y espacios =========== */
(function(){
  if(window.__MAI25){ return; }
  window.__MAI25=1;
  function isN(){ return location.pathname.indexOf('/pages/nosotras')>=0; }
  var CSS=[
    'body[data-mai-nos] .header-section,body[data-mai-nos] header-component{position:static!important;top:auto!important}',
    '.maiN__hero{padding-top:clamp(18px,2.5vw,34px)!important}',
    '.maiN__nace{padding-top:clamp(90px,11vw,180px)!important;padding-bottom:clamp(90px,11vw,180px)!important}',
    '.maiN__why{padding-top:clamp(80px,9vw,150px)!important;padding-bottom:clamp(80px,9vw,150px)!important;align-items:start!important}',
    '.maiN__why>div>.maiN__p:first-of-type{margin-top:clamp(36px,7vw,120px)!important}',
    '.maiN__more{padding-top:clamp(70px,8vw,140px)!important;padding-bottom:clamp(70px,8vw,140px)!important}',
    '.maiN__hot{padding-top:clamp(80px,10vw,165px)!important;padding-bottom:clamp(80px,10vw,165px)!important}',
    '.maiN__f1{left:12%!important;right:auto!important}',
    '.maiN__f2{left:-2%!important;right:auto!important}',
    '.maiN__f3{left:69.5%!important;right:auto!important}',
    '.maiN__f4{left:23.5%!important;right:auto!important}',
    '.maiN__f5{left:82%!important;right:auto!important}',
    '@media(max-width:900px){.maiN__hotSide{display:none!important}.maiN__hot{padding-left:clamp(16px,5vw,40px)!important;padding-right:clamp(16px,5vw,40px)!important}}'
  ].join('');
  function style(){
    if(!document.head){ return; }
    if(document.body&&isN()&&!document.body.hasAttribute('data-mai-nos')){ document.body.setAttribute('data-mai-nos','1'); }
    if(document.getElementById('mai25')){ return; }
    var s=document.createElement('style');
    s.id='mai25';
    s.textContent=CSS;
    document.head.appendChild(s);
  }
  var raf=0;
  function px3(){
    raf=0;
    var vh=window.innerHeight||800;
    var sp=[220,300,180,320,260];
    [].forEach.call(document.querySelectorAll('.maiN__f'),function(el,i){
      var r=el.getBoundingClientRect();
      var p=(vh-r.top)/(vh+r.height);
      if(p<0){ p=0; }
      if(p>1){ p=1; }
      var o=(p-0.02)*5;
      if(o<0){ o=0; }
      if(o>1){ o=1; }
      el.style.opacity=o.toFixed(2);
      el.style.transform='translateY('+((0.5-p)*sp[i%5]).toFixed(1)+'px)';
    });
  }
  function onScroll(){ if(!raf){ raf=requestAnimationFrame(px3); } }
  var bound=false;
  function run25(){
    if(!isN()){ return; }
    try{ style(); }catch(e){}
    if(!bound){
      bound=true;
      window.addEventListener('scroll',onScroll,{passive:true});
      window.addEventListener('resize',onScroll);
    }
    try{ px3(); }catch(e){}
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run25); } else { run25(); }
  setInterval(run25,900);
})();
(function(){
if(window.__MAI26) return; window.__MAI26=1;
var CSS=[
'.maiN__heroimg{aspect-ratio:auto!important;height:auto!important;object-fit:contain!important;width:100%!important;display:block}',
'.maiN__heropic{display:block}',
'body[data-mai-nos] .maiN__hero{position:relative;z-index:2;background:#fff}'
].join('');
var st=document.getElementById('mai26');
if(!st){ st=document.createElement('style'); st.id='mai26'; st.textContent=CSS; document.head.appendChild(st); }
function homeBtns(){
  var as=document.querySelectorAll('a.maiH__all');
  for(var i=0;i<as.length;i++){
    var a=as[i];
    var sec=a.closest('.shopify-section')||a.closest('section');
    var h=sec?sec.querySelector('h1,h2,h3'):null;
    var txt=h?h.textContent.toLowerCase():'';
    if(txt.indexOf('essential')>-1){ a.setAttribute('href','/collections/the-essentials'); a.style.display=''; }
    else { a.style.display='none'; }
  }
}
function run26(){ try{ homeBtns(); }catch(e){} }
if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run26); } else { run26(); }
setInterval(run26,900);
})();
(function(){
if(window.__MAI27) return; window.__MAI27=1;
function isEN(){ var p=location.pathname; return p==='/en'||p.indexOf('/en/')===0; }
function hdl(){ var p=location.pathname.split('/products/')[1]||''; return p.split('?')[0].split('/')[0].toLowerCase(); }
function model(){ var h=hdl(); if(h.indexOf('pipa')>-1) return 'pipa'; if(h.indexOf('saona')>-1) return 'saona'; if(h.indexOf('tayrona')>-1) return 'tayrona'; return ''; }
function isTop(){ return hdl().indexOf('top')>-1; }
var D={
 pipa:{ h:['Talla','Busto (cm)','Contorno bajo busto (cm)'], he:['Size','Bust (cm)','Underbust (cm)'],
   r:[['S','82-86','68-72'],['M','87-91','73-77'],['L','92-96','78-82']],
   n:'Top triangulo mini, con tiras y espalda regulables.', ne:'Mini triangle top with adjustable straps and back.' },
 saona:{ h:['Talla','Busto (cm)','Copa','Alto de copa (cm)'], he:['Size','Bust (cm)','Cup','Cup height (cm)'],
   r:[['S','82-86','A','11'],['M','87-91','B','11,5'],['L','92-96','C','12']],
   n:'Top con copa. La copa y el alto suben un nivel por talla.', ne:'Molded cup top. Cup and height go up one step per size.' },
 tayrona:{ h:['Talla','Busto (cm)','Contorno bajo busto (cm)','Ancho de copa (cm)','Alto de copa (cm)'], he:['Size','Bust (cm)','Underbust (cm)','Cup width (cm)','Cup height (cm)'],
   r:[['S','82-86','68-72','30,5','7,5'],['M','87-91','73-77','31,5','8'],['L','92-96','78-82','32,5','8,5']],
   n:'Corte underboob con tiras finas regulables.', ne:'Underboob cut with thin adjustable straps.' },
 bot:{ h:['Talla','Cintura (cm)','Cadera (cm)','Ancho lateral (cm)'], he:['Size','Waist (cm)','Hips (cm)','Side width (cm)'],
   r:[['S','62-66','88-92','5'],['M','67-71','93-97','6'],['L','72-76','98-102','7']],
   n:'Todas las braguitas son regulables: cada talla suma 1 cm de tela en los laterales.', ne:'All bottoms are adjustable: each size adds 1 cm of fabric at the sides.' }
};
function data(){ var m=model(); if(!isTop()) return D.bot; return D[m]||D.pipa; }
function tbl(){
 var d=data(), en=isEN(), head=en?d.he:d.h, s='<table class="maiT__tbl"><thead><tr>';
 for(var i=0;i<head.length;i++){ s+='<th>'+head[i]+'</th>'; }
 s+='</tr></thead><tbody>';
 for(var r=0;r<d.r.length;r++){ s+='<tr>'; for(var c=0;c<d.r[r].length;c++){ s+='<td>'+d.r[r][c]+'</td>'; } s+='</tr>'; }
 s+='</tbody></table>';
 s+='<p class="maiGT__note">'+(en?d.ne:d.n)+'</p>';
 s+='<p class="maiGT__note">'+(en?'Measurements in centimetres. If you are between two sizes, we recommend the larger one.':'Medidas en centimetros. Si estas entre dos tallas, te recomendamos elegir la mayor.')+'</p>';
 return s;
}
function fix27(){
 var ov=document.getElementById('maiGTov2'); if(!ov) return;
 var fb=ov.querySelector('#maiGTfb'); if(!fb) return;
 var key=model()+(isTop()?'-t':'-b')+(isEN()?'-en':'-es');
 if(fb.getAttribute('data-m27')===key) return;
 var im=ov.querySelector('#maiGTimg'); if(im){ im.style.display='none'; }
 fb.style.display='';
 fb.innerHTML=tbl();
 fb.setAttribute('data-m27',key);
 var sub=ov.querySelector('.maiGT__s');
 if(sub){ var m=model(); var nm=m?m.charAt(0).toUpperCase()+m.slice(1):''; sub.textContent=(isTop()?'Top':'Bottom')+(nm?' '+nm:''); }
}
setInterval(fix27,300);
})();
(function(){
if(window.__MAI28) return; window.__MAI28=1;
var V={'pipa-rojo':'901da2d0fcbc46fd86d2bac430600d3a','pipa-celeste':'d575045a63664df9bac980a71371a5ef','pipa-amarillo':'fee9b6fa60d24dce912482a6a5e18611','saona-wine':'258c7ecf17714683aac7a944e1226e87','saona-caramel':'d903acb2846e4f91b14be7b47abd85ea','saona-perla':'11e449e1d15c40538da018ff4db085b5'};
function hdl(){ var p=location.pathname.split('/products/')[1]||''; return p.split('?')[0].split('/')[0].toLowerCase(); }
function model(){ var h=hdl(); if(h.indexOf('pipa')>-1) return 'pipa'; if(h.indexOf('saona')>-1) return 'saona'; return ''; }
function color(){
 var e=document.querySelector('.maiPD__sub'); var t=(e?e.textContent:'').toLowerCase();
 if(t.indexOf('rojo')>-1||t.indexOf('red')>-1) return 'rojo';
 if(t.indexOf('celeste')>-1||t.indexOf('light blue')>-1) return 'celeste';
 if(t.indexOf('amarillo')>-1||t.indexOf('yellow')>-1) return 'amarillo';
 if(t.indexOf('vino')>-1||t.indexOf('wine')>-1) return 'wine';
 if(t.indexOf('caramel')>-1||t.indexOf('toffee')>-1||t.indexOf('cafe')>-1) return 'caramel';
 if(t.indexOf('perla')>-1||t.indexOf('pearl')>-1) return 'perla';
 return '';
}
function css28(){ if(document.getElementById('mai28s')) return; var s=document.createElement('style'); s.id='mai28s'; s.textContent='.maiVid{margin-top:10px;border-radius:14px;overflow:hidden;line-height:0}.maiVid video{width:100%;height:auto;display:block;border-radius:14px}'; document.head.appendChild(s); }
function run28(){
 var m=model(); if(!m) return;
 var c=color(); if(!c) return;
 var key=m+'-'+c; var h=V[key]; if(!h) return;
 var pg=document.querySelector('.maiPG'); if(!pg) return;
 css28();
 var box=document.getElementById('maiVid28');
 if(!box){
  box=document.createElement('div'); box.id='maiVid28'; box.className='maiVid';
  box.innerHTML='<video muted loop playsinline autoplay preload="metadata"></video>';
  pg.parentNode.insertBefore(box,pg.nextSibling);
 }
 var v=box.querySelector('video');
 var url='https://cdn.shopify.com/videos/c/o/v/'+h+'.mp4';
 if(v.getAttribute('data-k')!==key){ v.setAttribute('data-k',key); v.src=url; v.muted=true; var p=v.play(); if(p&&p.catch){ p.catch(function(){}); } }
}
setInterval(run28,700);
if(document.readyState!=='loading'){ run28(); } else { document.addEventListener('DOMContentLoaded',run28); }
})();
(function(){
if(window.__MAI29) return; window.__MAI29=1;
var P={};
function fmt(n){ var s=String(n); var o=''; var c=0; for(var i=s.length-1;i>=0;i--){ o=s.charAt(i)+o; c++; if(c%3===0&&i>0){ o='.'+o; } } return '$'+o; }
function paint29(){
 var els=document.querySelectorAll('.maiH__price');
 for(var i=0;i<els.length;i++){
  var el=els[i]; var meta=el.parentElement; if(!meta) continue;
  var nm=meta.querySelector('.maiH__name'); if(!nm) continue;
  var key=nm.textContent.trim().toUpperCase(); var v=P[key]; if(!v) continue;
  if(el.getAttribute('data-clp')===String(v)) continue;
  var txt=fmt(v);
  el.setAttribute('data-orig',txt); el.setAttribute('data-clp',String(v));
  el.setAttribute('data-o8',txt); el.setAttribute('data-c8',String(v));
  el.textContent=txt;
 }
}
function load29(){
 fetch('/collections/all/products.json?limit=50').then(function(r){ return r.json(); }).then(function(j){
  (j.products||[]).forEach(function(p){
   var min=null;
   (p.variants||[]).forEach(function(v){ var n=Math.round(parseFloat(v.price)); if(min===null||n<min){ min=n; } });
   if(min!==null){ P[String(p.title).trim().toUpperCase()]=min; }
  });
  paint29();
 }).catch(function(){});
}
load29();
setInterval(paint29,800);
})();
(function(){
if(window.__MAI30) return; window.__MAI30=1;
function isEN(){ var p=location.pathname; return p==="/en"||p.indexOf("/en/")===0; }
var D={
"Inicio":"Home",
"Comprar ahora":"Buy now",
"COMPRAR AHORA":"BUY NOW",
"Cómpralo con":"Buy it with",
"Agregar":"Add",
"AGREGAR":"ADD",
"Descripción":"Description",
"DESCRIPCIÓN":"DESCRIPTION",
"Composición y cuidado":"Composition and care",
"Envíos y entregas":"Shipping and delivery",
"¿Cómo elijo mi talla?":"How do I choose my size?",
"Te pueden gustar":"You may also like",
"Seguridad y políticas":"Security and policies",
"Ayuda":"Help",
"AYUDA":"HELP",
"Conócenos":"Get to know us",
"Ya confían en MAI ♡":"They already trust MAI ♡",
"Síguenos en Instagram @maiswimsuits":"Follow us on Instagram @maiswimsuits",
"¿Cómo nace MAI?":"How was MAI born?",
"¿Por qué MAI?":"Why MAI?",
"Más que":"More than",
"un bikini ...":"a bikini ...",
"Sentirse hot sin pedir permiso":"Feeling hot without asking permission",
"Todo empezó con una búsqueda que nunca terminaba...":"It all started with a search that never ended...",
"Pipe":"Pipa",
"New colecction":"New collection",
"© 2026 MAI · Todos los derechos reservados":"© 2026 MAI · All rights reserved",
"Buscamos el bikini perfecto. Como no lo encontramos, lo hicimos nosotras.":"We looked for the perfect bikini. Since we could not find it, we made it ourselves.",
"Somos MAI. El nombre viene de la abreviación de MIA al revés, donde viví y me inspiré en nuevas tendencias y en nuestra identidad latina: seguras de nosotras mismas y siempre cautivadoras. Hacemos nuestros bikinis en Colombia, con herrajes bañados en oro que no se destiñen y telas premium pensadas para durar años, no una temporada. Bikinis para vivir en ellos, dentro y fuera del agua. Bienvenida, ahora eres del grupo.":"We are MAI. The name comes from MIA spelled backwards, the city where I lived and found inspiration in new trends and in our Latin identity: sure of ourselves and always captivating. We make our bikinis in Colombia, with gold-plated hardware that does not fade and premium fabrics built to last for years, not one season. Bikinis to live in, in and out of the water. Welcome, you are one of us now.",
"Paula había recorrido tiendas y miles de marcas buscando el bikini perfecto. Ese que se siente como una segunda piel, que se ve espectacular y que no te obliga a elegir entre verte bien y estar cómoda. Nunca lo encontró. Así que dejamos de buscarlo. Y decidimos crearlo. Un traje de baño pensado por mujeres que sabemos exactamente lo que queremos sentir cuando nos lo ponemos.":"Paula had been through countless stores and thousands of brands looking for the perfect bikini. The one that feels like a second skin, looks spectacular and never makes you choose between looking good and being comfortable. She never found it. So we stopped looking for it. And we decided to create it. A swimsuit designed by women who know exactly how we want to feel when we put it on.",
"Esta idea nació en Miami, esa ciudad le confirmó a Paula algo que ya llevábamos dentro: las latinas tenemos un fuego propio, una manera de ser hot sin esfuerzo. MAI es nuestro homenaje a eso. Y suena como my. Porque es justo lo que queremos que sientas cada vez que lo dices: que es tuyo, propio, absolutamente tuyo.":"This idea was born in Miami. That city confirmed something we already carried inside: Latin women have a fire of our own, a way of being hot without even trying. MAI is our tribute to that. And it sounds like my. Because that is exactly what we want you to feel every time you say it: that it is yours, your own, absolutely yours.",
"Diseñamos trajes de baño, y lo hacemos con obsesión por el detalle porque creemos que en lo simple está lo importante. Cuando creamos MAI, lo pensamos como un acompañante para todas partes.":"We design swimwear, and we do it with an obsession for detail because we believe the important things live in the simple ones. When we created MAI, we thought of it as a companion for everywhere.",
"Nuestros bikinis están hechos para ir más allá de la playa: llevarlos al gym, salir a la calle bajo un total look, pasar del mar a un almuerzo sin cambiarte. Son tan cómodos que se vuelven parte de tu vida, no solo de tus vacaciones.":"Our bikinis are made to go beyond the beach: wear them to the gym, out on the street under a total look, straight from the sea to lunch without changing. They are so comfortable they become part of your life, not just your holidays.",
"Porque sentirse hot no va de gustarle a nadie, va de mirarte y saber que estás increíble. MAI es esa seguridad hecha tela. Sensualidad con clase, actitud sin esfuerzo.":"Because feeling hot is not about pleasing anyone, it is about looking at yourself and knowing you look incredible. MAI is that confidence made fabric. Sensuality with class, attitude without effort.",
"Y todo esto nace de lo que somos: latinas, y se nota. En el color, en la calidez, en esa manera nuestra de habitar el cuerpo con confianza. MAI es una carta de amor a lo que somos: mujeres latinas que ocupan su lugar, disfrutan del sol y llevan su origen con orgullo a donde vayan.":"And all of this comes from what we are: Latinas, and it shows. In the colour, in the warmth, in our way of inhabiting the body with confidence. MAI is a love letter to what we are: Latin women who take up their space, enjoy the sun and carry their roots with pride wherever they go.",
"80% poliamida y 20% elastano (spandex): ajuste cómodo, elasticidad, secado rápido y buena resistencia al uso, manteniendo la forma y el color por más tiempo. Lávalo a mano con agua fría, sin lavadora, sin secadora y sin cloro ni blanqueadores. Sécalo a la sombra y evita el contacto prolongado con superficies ásperas para proteger la tela.":"80% polyamide and 20% elastane (spandex): comfortable fit, stretch, quick drying and good resistance to wear, keeping its shape and colour for longer. Hand wash in cold water: no washing machine, no dryer, no chlorine or bleach. Dry in the shade and avoid prolonged contact with rough surfaces to protect the fabric.",
"Enviamos desde Chile. Dentro de Chile llega en hasta 5 días hábiles; los envíos internacionales tardan hasta 20 días hábiles según el país de destino. El costo del envío se calcula automáticamente en el checkout según tu dirección. En períodos de alta demanda los plazos pueden extenderse.":"We ship from Chile. Within Chile it arrives in up to 5 business days; international orders take up to 20 business days depending on the destination country. Shipping cost is calculated automatically at checkout based on your address. During periods of high demand these times may be longer.",
"Tienes 10 días corridos desde que recibes tu pedido para solicitar un cambio. La prenda debe estar sin uso, con sus etiquetas originales, en perfectas condiciones y con su empaque original. Por tratarse de ropa de uso íntimo, revisamos cada solicitud antes de aprobarla. Los costos de envío del cambio o la devolución son responsabilidad del cliente.":"You have 10 calendar days from the moment you receive your order to request an exchange. The item must be unworn, with its original tags, in perfect condition and in its original packaging. As this is intimate apparel, we review every request before approving it. Shipping costs for the exchange or return are the responsibility of the customer.",
"Revisa nuestra Guía de Tallas: ahí están todas las medidas para elegir la talla ideal. Si quedas entre dos o tienes dudas, escríbenos y te ayudamos a elegir.":"Check our Size Guide: it has all the measurements you need to pick your ideal size. If you are between two sizes or have any doubts, write to us and we will help you choose."
};
function tr30(){
 if(!isEN()) return;
 var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null,false);
 var list=[]; var n;
 while(n=w.nextNode()){ list.push(n); }
 for(var i=0;i<list.length;i++){
  var node=list[i]; var t=node.nodeValue; var k=t.trim();
  if(!k) continue;
  var v=D[k];
  if(v!==undefined && v!==t){ node.nodeValue=t.split(k).join(v); }
 }
}
setInterval(tr30,900);
if(document.readyState!=="loading"){ tr30(); } else { document.addEventListener("DOMContentLoaded",tr30); }
})();
(function(){
if(window.__MAI31) return; window.__MAI31=1;
function isEN(){ var p=location.pathname; return p==="/en"||p.indexOf("/en/")===0; }
if(!isEN()) return;
var D={
"¿Cuánto tarda en llegar mi pedido?":"How long will my order take to arrive?",
"Realizamos envíos desde Chile.":"We ship from Chile.",
"Envíos dentro de Chile: hasta 5 días hábiles.":"Within Chile: up to 5 business days.",
"Envíos internacionales: hasta 20 días hábiles, dependiendo del país de destino. En períodos de alta demanda o por factores logísticos externos, los tiempos de entrega podrían extenderse.":"International: up to 20 business days, depending on the destination country. During periods of high demand or because of external logistics factors, delivery times may be longer.",
"¿Cuánto cuesta el envío?":"How much does shipping cost?",
"El costo del envío depende del destino y se calcula automáticamente al finalizar tu compra, antes de realizar el pago.":"Shipping cost depends on the destination and is calculated automatically at checkout, before you pay.",
"¿Hacen envíos internacionales?":"Do you ship internationally?",
"Sí. Enviamos a la mayoría de los países. Los costos y tiempos de entrega se calculan automáticamente durante el proceso de compra según tu ubicación.":"Yes. We ship to most countries. Costs and delivery times are calculated automatically during checkout based on your location.",
"¿Envían a mi zona?":"Do you ship to my area?",
"Ingresa tu dirección durante el checkout y nuestro sistema te indicará automáticamente si realizamos envíos a tu ubicación. Si tienes alguna duda, puedes escribirnos y estaremos felices de ayudarte.":"Enter your address at checkout and our system will tell you automatically whether we ship to your location. If you have any doubts, write to us and we will be happy to help.",
"¿Qué métodos de pago aceptan?":"What payment methods do you accept?",
"Aceptamos pagos mediante Webpay (Transbank) y otras pasarelas de pago disponibles a través de Shopify, incluyendo las principales tarjetas de crédito y débito como Visa, Mastercard y American Express (según disponibilidad en tu país).":"We accept Webpay (Transbank) and other payment gateways available through Shopify, including major credit and debit cards such as Visa, Mastercard and American Express (subject to availability in your country).",
"¿Puedo pagar en cuotas?":"Can I pay in instalments?",
"Sí. La posibilidad de pagar en cuotas dependerá de las condiciones de tu tarjeta de crédito y del medio de pago seleccionado.":"Yes. Paying in instalments depends on the terms of your credit card and the payment method you choose.",
"¿Puedo modificar o cancelar mi pedido?":"Can I change or cancel my order?",
"Sí, siempre que tu pedido aún no haya sido despachado. Contáctanos lo antes posible para revisar tu caso.":"Yes, as long as your order has not been dispatched yet. Contact us as soon as possible so we can review your case.",
"¿Mis datos de pago están seguros?":"Is my payment information safe?",
"Sí. Todas nuestras pasarelas de pago cumplen con los estándares internacionales de seguridad PCI-DSS, utilizados por las principales marcas como Visa, Mastercard y American Express. Tus datos son procesados de forma segura y nunca almacenamos la información de tu tarjeta.":"Yes. All our payment gateways meet the international PCI-DSS security standards used by major brands such as Visa, Mastercard and American Express. Your data is processed securely and we never store your card details.",
"¿Cuánto tiempo tengo para cambiar una prenda?":"How long do I have to exchange an item?",
"Dispones de 10 días corridos desde la recepción de tu pedido para solicitar un cambio. La prenda debe:":"You have 10 calendar days from receiving your order to request an exchange. The item must:",
"Estar sin uso.":"Be unworn.",
"Mantener sus etiquetas originales.":"Keep its original tags.",
"Estar en perfectas condiciones.":"Be in perfect condition.",
"Conservar su empaque original. Por tratarse de ropa de uso íntimo, todas las solicitudes serán revisadas antes de ser aprobadas.":"Keep its original packaging. As this is intimate apparel, every request is reviewed before being approved.",
"¿El cambio tiene costo?":"Is there a cost for an exchange?",
"Sí. Los costos de envío asociados al cambio, incluyendo el envío de devolución y el nuevo despacho, son responsabilidad del cliente.":"Yes. Shipping costs for the exchange, including the return shipment and the new delivery, are the responsibility of the customer.",
"¿Cómo solicito un cambio o reembolso?":"How do I request an exchange or refund?",
"Contáctanos a través de nuestros canales de atención indicando tu número de pedido y el motivo de la solicitud. Revisaremos tu caso y te responderemos lo antes posible.":"Contact us through our support channels with your order number and the reason for your request. We will review your case and reply as soon as possible.",
"¿Cuándo puedo solicitar un reembolso?":"When can I request a refund?",
"Si tu producto presenta una falla de fabricación o desperfecto, puedes solicitar un reembolso dentro de los 10 días corridos desde la recepción del pedido.":"If your product has a manufacturing fault or defect, you can request a refund within 10 calendar days of receiving your order.",
"¿Cuánto me pueden reembolsar?":"How much can I be refunded?",
"El monto dependerá del estado del producto.":"The amount depends on the condition of the product.",
"Si el producto está sin uso, con etiquetas y en perfectas condiciones, podrás optar a un reembolso completo.":"If the product is unworn, with tags and in perfect condition, you can get a full refund.",
"Si el producto fue utilizado, presenta daños por uso o no conserva sus condiciones originales, no será posible realizar el reembolso.":"If the product has been used, shows damage from use or is not in its original condition, a refund is not possible.",
"Los productos con daños ocasionados por un mal uso no califican para reembolso.":"Products damaged by misuse do not qualify for a refund.",
"¿Quién paga el envío en una devolución?":"Who pays for return shipping?",
"Los costos de envío asociados a una devolución son responsabilidad del cliente, incluso cuando el pedido original haya contado con envío gratuito.":"Shipping costs for a return are the responsibility of the customer, even when the original order had free shipping.",
"¿Cómo sé cuál es mi talla?":"How do I know my size?",
"Puedes consultar nuestra Guía de Tallas, donde encontrarás todas las medidas necesarias para elegir la talla ideal.":"You can check our Size Guide, where you will find all the measurements you need to pick your ideal size.",
"¿De qué material están hechos los bikinis?":"What are the bikinis made of?",
"Nuestros bikinis están confeccionados con:":"Our bikinis are made with:",
"80% Poliamida":"80% Polyamide",
"20% Elastano (Spandex). Esta combinación entrega un ajuste cómodo, elasticidad, secado rápido y excelente resistencia al uso, manteniendo la forma y el color de la prenda por más tiempo.":"20% Elastane (Spandex). This combination gives a comfortable fit, stretch, quick drying and excellent resistance to wear, keeping the shape and colour of the garment for longer.",
"¿Cómo debo cuidar mi bikini?":"How should I care for my bikini?",
"Para mantener tu bikini en las mejores condiciones te recomendamos:":"To keep your bikini in the best condition we recommend:",
"Lavar a mano con agua fría.":"Hand wash in cold water.",
"No usar lavadora.":"Do not use a washing machine.",
"No usar secadora.":"Do not use a dryer.",
"No utilizar cloro ni blanqueadores.":"Do not use chlorine or bleach.",
"Secar a la sombra.":"Dry in the shade.",
"Evitar el contacto prolongado con superficies ásperas para proteger la tela.":"Avoid prolonged contact with rough surfaces to protect the fabric.",
"¿Dónde están diseñados y fabricados?":"Where are they designed and made?",
"Nuestros bikinis son diseñados en Londres y confeccionados éticamente por talentosas mujeres colombianas, utilizando materiales de alta calidad y la reconocida confección colombiana, referente mundial en moda de baño.":"Our bikinis are designed in London and ethically made by talented Colombian women, using high quality materials and the renowned Colombian craftsmanship, a world reference in swimwear.",
"¿Los bikinis tienen garantía?":"Do the bikinis have a warranty?",
"Sí. Todos nuestros productos pasan por un estricto control de calidad antes de ser enviados. Nuestra garantía cubre exclusivamente defectos de fabricación, materiales o confección. Si detectas algún problema, contáctanos tan pronto como sea posible para revisar tu caso. La garantía no cubre:":"Yes. All our products go through strict quality control before being shipped. Our warranty covers manufacturing, material or workmanship defects only. If you notice a problem, contact us as soon as possible so we can review your case. The warranty does not cover:",
"Daños por uso indebido.":"Damage from misuse.",
"Desgaste normal.":"Normal wear.",
"Cortes, enganches o rasgaduras.":"Cuts, snags or tears.",
"Daños ocasionados por un lavado o cuidado incorrecto.":"Damage caused by incorrect washing or care.",
"Preguntas frecuentes":"Frequently asked questions",
"¿Aún tienes dudas?":"Still have questions?",
"Escríbenos y con gusto te ayudamos.":"Write to us and we will gladly help.",
"Contáctanos":"Contact us",
"Nuestros bikinis están hechos con 80% poliamida y 20% elastano, una combinación que entrega ajuste, elasticidad y secado rápido. Con los cuidados correctos, tu bikini mantendrá su forma y color por mucho más tiempo.":"Our bikinis are made with 80% polyamide and 20% elastane, a blend that gives fit, stretch and quick drying. With the right care, your bikini will keep its shape and colour for much longer.",
"Lava tu bikini a mano con agua fría después de cada uso. Esto ayuda a eliminar el cloro, la sal y el protector solar.":"Hand wash your bikini in cold water after every use. This helps remove chlorine, salt and sunscreen.",
"La lavadora puede dañar las fibras y deformar tu bikini. Siempre lávalo a mano con un jabón suave.":"A washing machine can damage the fibres and misshape your bikini. Always hand wash it with a mild soap.",
"Nunca lo pongas en la secadora. Déjalo secar al aire libre, a la sombra, para proteger el color y la elasticidad.":"Never put it in the dryer. Let it air dry in the shade to protect the colour and the stretch.",
"Sin químicos":"No chemicals",
"No utilices cloro, blanqueadores ni detergentes agresivos. Un jabón neutro es todo lo que necesitas.":"Do not use chlorine, bleach or harsh detergents. A mild soap is all you need.",
"Evita el contacto prolongado con superficies ásperas como bordes de piscina o arena gruesa para proteger la tela.":"Avoid prolonged contact with rough surfaces such as pool edges or coarse sand to protect the fabric.",
"Guárdalo seco y plano, sin dobleces fuertes. Evita dejarlo húmedo en una bolsa por mucho tiempo.":"Store it dry and flat, without hard creases. Avoid leaving it damp in a bag for a long time.",
"Enjuagar después de cada uso":"Rinse after every use",
"Lavar con agua fría y jabón neutro":"Wash with cold water and mild soap",
"Dejarlo húmedo guardado":"Storing it while damp",
"Con estos sencillos cuidados, tu bikini MAI te acompañará por muchas temporadas.":"With this simple care, your MAI bikini will stay with you for many seasons.",
"¿La próxima MAI girl? Sube tu foto etiquetándonos en IG":"The next MAI girl? Post your photo and tag us on IG",
"y la próxima podrías ser tú...":"and the next one could be you...",
"Esta colección esta inspirada en …":"This collection is inspired by …"
};
var CAT={"Cambios, devoluciones y reembolsos":"Exchanges, returns and refunds","Pedidos y pagos":"Orders and payments","Producto y tallas":"Product and sizes","Garantía":"Warranty","Envíos":"Shipping"};
function tr31(){
 var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null,false);
 var list=[]; var n;
 while(n=w.nextNode()){ list.push(n); }
 for(var i=0;i<list.length;i++){
  var node=list[i]; var t=node.nodeValue; var k=t.trim();
  if(!k) continue;
  var v=D[k];
  if(v!==undefined && v!==t){ node.nodeValue=t.split(k).join(v); }
 }
 var hs=document.querySelectorAll(".maiQ__cath");
 for(var j=0;j<hs.length;j++){
  var h=hs[j]; var tx=h.textContent;
  for(var key in CAT){ if(tx.indexOf(key)>-1){ h.textContent=tx.split(key).join(CAT[key]); break; } }
 }
}
function enLinks(){
 var as=document.querySelectorAll("a[href]");
 for(var i=0;i<as.length;i++){
  var a=as[i]; var h=a.getAttribute("href");
  if(!h||h.charAt(0)!=="/") continue;
  if(h.indexOf("/en/")===0||h==="/en") continue;
  if(h.indexOf("/cdn/")===0||h.indexOf("/account")===0||h.indexOf("/customer_")===0||h.indexOf("/cart")===0||h.indexOf("/checkout")===0) continue;
  a.setAttribute("href","/en"+h);
 }
}
function run31(){ try{ tr31(); }catch(e){} try{ enLinks(); }catch(e){} }
setInterval(run31,900);
if(document.readyState!=="loading"){ run31(); } else { document.addEventListener("DOMContentLoaded",run31); }
})();
(function(){
if(window.__MAI32) return; window.__MAI32=1;
function isEN(){ var p=location.pathname; return p==="/en"||p.indexOf("/en/")===0; }
if(!isEN()) return;
var D={
"✕ Evítalo":"✕ Avoid this",
"Correo electrónico":"Email",
"Selecciona el motivo de tu mensaje":"Select the reason for your message",
"Estado de mi pedido":"Order status",
"Dudas de talla":"Size questions",
"Garantia de un producto":"Product warranty",
"Colaboraciones y prensa":"Collaborations and press",
"Otro":"Other",
"HORARIO":"HOURS",
"Lunes a viernes, 9:00 – 18:00 (CLT)":"Monday to Friday, 9:00 – 18:00 (CLT)",
"Responderemos tu mensaje en un plazo de 24-48 horas hábiles.":"We reply to every message within 24 to 48 business hours."
};
var PH={
"Escribe tu nombre y apellido":"Enter your first and last name",
"ejemplo@correo.com":"example@email.com",
"Cuéntanos cómo podemos ayudarte...":"Tell us how we can help...",
"Correo electrónico":"Email address"
};
function tr32(){
 var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null,false);
 var list=[]; var n;
 while(n=w.nextNode()){ list.push(n); }
 for(var i=0;i<list.length;i++){
  var node=list[i]; var t=node.nodeValue; var k=t.trim();
  if(!k) continue;
  var v=D[k];
  if(v!==undefined && v!==t){ node.nodeValue=t.split(k).join(v); }
 }
 var fs=document.querySelectorAll("input,textarea");
 for(var j=0;j<fs.length;j++){
  var el=fs[j]; var p=el.getAttribute("placeholder");
  if(p && PH[p]){ el.setAttribute("placeholder",PH[p]); }
 }
}
setInterval(tr32,900);
if(document.readyState!=="loading"){ tr32(); } else { document.addEventListener("DOMContentLoaded",tr32); }
})();
(function(){
if(window.__MAI33) return; window.__MAI33=1;
var CSS=[
'.maiPD__now{display:none!important}',
'.shopify-payment-button__button--unbranded{background:#fff!important;color:#111!important;border:1px solid #111!important;border-radius:999px!important;font-family:Poppins,sans-serif!important;font-size:12px!important;font-weight:600!important;letter-spacing:1.08px!important;text-transform:uppercase!important;min-height:50px!important;padding:15px 20px!important;box-shadow:none!important;transition:background .2s ease,color .2s ease}',
'.shopify-payment-button__button--unbranded:hover{background:#111!important;color:#fff!important}',
'.maiMq{overflow:hidden;width:100%;position:relative;display:block}',
'.maiMq__t{display:flex;width:max-content;animation:maiMqA 40s linear infinite;will-change:transform}',
'.maiMq__g{display:flex}',
'.maiMq__i{font-family:Poppins,sans-serif;font-size:12px;letter-spacing:.09em;text-transform:uppercase;color:rgba(0,0,0,.81);white-space:nowrap;padding:0 26px;line-height:1}',
'@keyframes maiMqA{from{transform:translateX(0)}to{transform:translateX(-50%)}}',
'@media(prefers-reduced-motion:reduce){.maiMq__t{animation:none}}'
].join('');
function css33(){ if(document.getElementById('mai33')) return; var s=document.createElement('style'); s.id='mai33'; s.textContent=CSS; document.head.appendChild(s); }
function marquee(){
 var bar=document.querySelector('.announcement-bar');
 if(!bar) return;
 var p=bar.querySelector('.announcement-bar__text');
 var txt=p?p.textContent.trim():'';
 if(!txt) return;
 var old=document.getElementById('maiMq33');
 if(old && old.getAttribute('data-txt')===txt) return;
 if(old && old.parentNode){ old.parentNode.removeChild(old); }
 var comp=bar.querySelector('announcement-bar-component');
 if(comp){ comp.style.display='none'; }
 var unit='';
 for(var i=0;i<12;i++){ unit+='<span class="maiMq__i">'+txt+'</span>'; }
 var host=document.createElement('div');
 host.className='maiMq'; host.id='maiMq33'; host.setAttribute('data-txt',txt);
 host.innerHTML='<div class="maiMq__t"><div class="maiMq__g">'+unit+'</div><div class="maiMq__g">'+unit+'</div></div>';
 bar.appendChild(host);
}
function run33(){ css33(); try{ marquee(); }catch(e){} }
if(document.readyState!=="loading"){ run33(); } else { document.addEventListener("DOMContentLoaded",run33); }
setInterval(run33,1500);
})();
/* v34 guia de tallas MAI */ (function(){if(window.__MAIGT34)return;window.__MAIGT34=1;function hdl34(){var p=(location.pathname.split('/products/')[1]||'');return p.split('?')[0].split('/')[0].toLowerCase();}function isTop34(){return hdl34().indexOf('top')>-1;}function model34(){var h=hdl34();return h.indexOf('pipa')>-1?'pipa':h.indexOf('saona')>-1?'saona':h.indexOf('tayrona')>-1?'tayrona':'';}function isEN34(){return location.pathname.indexOf('/en/')===0;}var TH={h:['Talla','Busto (cm)','Copa aprox.'],he:['Size','Bust (cm)','Approx. cup'],r:[['S','80-88','A-B'],['M','89-97','B-C'],['L','98-108','C-D']]};var BH={h:['Talla','Cadera (cm)'],he:['Size','Hips (cm)'],r:[['S','86-94'],['M','95-103'],['L','104-112']]};var N1='Todas nuestras piezas son ajustables: se amarran con nudos y varios modelos traen además su propio sistema de ajuste, así que puedes afinar el calce a tu medida.';var N1E='All our pieces are adjustable: they tie with knots and several styles also have their own built-in adjustment, so you can fine-tune the fit.';var N2='Medidas en centímetros. Si estás entre dos tallas, te recomendamos elegir la mayor.';var N2E='Measurements in centimetres. If you are between two sizes, we recommend the larger one.';function tbl34(){var d=isTop34()?TH:BH,en=isEN34(),head=en?d.he:d.h,s='<table class="maiT__tbl"><thead><tr>',i,r,c;for(i=0;i<head.length;i++)s+='<th>'+head[i]+'</th>';s+='</tr></thead><tbody>';for(r=0;r<d.r.length;r++){s+='<tr>';for(c=0;c<d.r[r].length;c++)s+='<td>'+d.r[r][c]+'</td>';s+='</tr>';}s+='</tbody></table>';s+='<p class="maiGT__note">'+(en?N1E:N1)+'</p>';s+='<p class="maiGT__note">'+(en?N2E:N2)+'</p>';return s;}function fix34(){var ov=document.getElementById('maiGTov2');if(!ov)return;var fb=ov.querySelector('#maiGTfb');if(!fb)return;var base=model34()+(isTop34()?'-t':'-b')+(isEN34()?'-en':'-es'),key=base+'-v34';if(fb.getAttribute('data-m34')===key)return;var im=ov.querySelector('#maiGTimg');if(im)im.style.display='none';fb.style.display='';fb.innerHTML=tbl34();fb.setAttribute('data-m27',base);fb.setAttribute('data-m34',key);var sub=ov.querySelector('.maiGT__s');if(sub){var m=model34(),nm=m?m.charAt(0).toUpperCase()+m.slice(1):'';sub.textContent=(isTop34()?'Top':'Bottom')+(nm?' '+nm:'');}}setInterval(fix34,200);})();
/* v35 pagina tallas MAI */ (function(){if(window.__MAIGT35)return;window.__MAIGT35=1;var LK='/pages/tallas';function pg35(){var p=location.pathname.replace(/^\/en/,'');return p.indexOf('/pages/tallas')===0||p.indexOf('/pages/guia-de-tallas')===0||(location.hash||'').indexOf('mai=tallas')>-1;}function tb35(head,rows){var s='<div class="maiT__wrap"><table class="maiT__tbl"><thead><tr>',i,r,c;for(i=0;i<head.length;i++)s+='<th>'+head[i]+'</th>';s+='</tr></thead><tbody>';for(r=0;r<rows.length;r++){s+='<tr>';for(c=0;c<rows[r].length;c++)s+='<td>'+rows[r][c]+'</td>';s+='</tr>';}return s+'</tbody></table></div>';}function cd35(a){var s='<div class="maiT__tips">',i;for(i=0;i<a.length;i++)s+='<div class="maiT__tip"><div class="maiT__tipT">'+a[i][0]+'</div><p class="maiT__tipC">'+a[i][1]+'</p></div>';return s+'</div>';}function html35(){var MOD=[['PIPA','Top triángulo mini, con tiras y espalda regulables.'],['SAONA','Top con copa. La copa y el alto suben un nivel por talla.'],['TAYRONA','Corte underboob con tiras finas regulables.']];var TIP=[['¿Entre dos tallas?','Elige la talla más grande, vas a estar más cómoda.'],['Combina tallas','Puedes usar una talla en el top y otra en el bottom.'],['Todo se ajusta','Todas las piezas se amarran con nudos y varios modelos traen además su propio sistema de ajuste.']];var PAS=[['Busto','Mide alrededor de la parte más ancha de tu busto, manteniendo la cinta métrica horizontal.'],['Cadera','Mide alrededor de la parte más ancha de tus caderas.']];var pasos='',i;for(i=0;i<PAS.length;i++)pasos+='<div><div class="maiT__num">'+(i+1)+'</div><div class="maiT__st">'+PAS[i][0]+'</div><p class="maiT__sd">'+PAS[i][1]+'</p></div>';var sv='<svg width="180" height="136" viewBox="0 0 180 136" fill="none" stroke="#c4c4c4" stroke-width="1.4"><circle cx="90" cy="56" r="32"></circle><line x1="0" y1="113" x2="180" y2="113"></line><line x1="30" y1="135" x2="150" y2="135"></line></svg>';var S1='<section class="maiT__sec">',H2='<h2 class="maiT__h2">',SB='<p class="maiT__sub">';var h='<section class="maiT__hero"><h1 class="maiT__t">Guía de tallas</h1>'+SB+'Encuentra tu talla perfecta</p></section>';h+=S1+H2+'Cómo tomar tus medidas</h2><div class="maiT__steps" style="grid-template-columns:repeat(2,minmax(0,1fr));max-width:720px;margin:0 auto">'+pasos+'</div></section>';h+=S1+'<div class="maiT__tt">Tops</div>'+SB+'Mismas medidas para Pipa, Saona y Tayrona.</p>'+tb35(['Talla','Busto (cm)','Copa aprox.'],[['S','80-88','A-B'],['M','89-97','B-C'],['L','98-108','C-D']])+'<div class="maiT__tt">Bottoms</div>'+tb35(['Talla','Cadera (cm)'],[['S','86-94'],['M','95-103'],['L','104-112']])+SB+'Todas nuestras piezas son ajustables: se amarran con nudos y varios modelos traen además su propio sistema de ajuste, así que puedes afinar el calce a tu medida. Medidas en centímetros. Si estás entre dos tallas, te recomendamos elegir la mayor.</p></section>';h+=S1+H2+'Nuestros modelos</h2>'+cd35(MOD)+'</section>';h+=S1+H2+'Tips para elegir tu talla</h2>'+cd35(TIP)+'</section>';h+='<section class="maiT__sec" style="text-align:center">'+H2+'¿Dudas con tu talla?</h2>'+SB+'Escríbenos y te ayudamos a elegir.</p><a href="/pages/contact" style="display:inline-block;margin-top:18px;padding:14px 36px;background:#111;color:#fff;text-decoration:none;font-size:12px;letter-spacing:.1em">CONTÁCTANOS</a></section>';return h;}function ft35(){var c=document.querySelectorAll('.maiF__col'),i,t,u,l;for(i=0;i<c.length;i++){t=((c[i].querySelector('h4')||{}).textContent||'');if(/ayuda|help/i.test(t)){u=c[i].querySelector('ul');if(u&&!u.querySelector('a[href*="'+LK+'"]')){l=document.createElement('li');l.innerHTML='<a href="'+LK+'">Guía de tallas</a>';u.insertBefore(l,u.firstChild);}}}}function run35(){ft35();if(!pg35())return;var m=document.querySelector('main');if(!m||m.getAttribute('data-mai35')==='1')return;m.setAttribute('data-mai3','1');m.className='maiP maiT';m.innerHTML=html35();m.setAttribute('data-mai35','1');}setInterval(run35,300);})();
/* v36 menu tallas + hero MAI */ (function(){if(window.__MAIGT36)return;window.__MAIGT36=1;var EXT=['jpg','png','jpeg','webp'],IMG='';function hero36(){var s=document.querySelector('.maiT__hero');if(!s||!IMG||s.getAttribute('data-i36'))return;s.setAttribute('data-i36','1');s.style.cssText+=';position:relative;background-image:linear-gradient(rgba(0,0,0,.3),rgba(0,0,0,.3)),url('+IMG+');background-size:cover;background-position:center;min-height:420px;display:flex;flex-direction:column;align-items:center;justify-content:center';var h=s.querySelector('.maiT__t'),p=s.querySelector('.maiT__sub');if(h)h.style.color='#fff';if(p)p.style.color='#fff';}function probe36(i){if(i>=EXT.length)return;var u='/cdn/shop/files/tallas-hero.'+EXT[i]+'?width=2000',im=new Image();im.onload=function(){IMG=u;hero36();};im.onerror=function(){probe36(i+1);};im.src=u;}function dw36(){var n=document.querySelector('.maiDw__nav');if(!n||n.querySelector('a[href$="/pages/tallas"]'))return;var a=document.createElement('a');a.className='maiDw__row';a.href='/pages/tallas';a.textContent='Guía de tallas';a.style.cssText='text-decoration:none;display:flex;align-items:center;justify-content:space-between';n.appendChild(a);}setInterval(function(){dw36();hero36();},400);probe36(0);})();
/* v38 banner conoce mai -> historia */ (function(){if(window.__MAIGT38)return;window.__MAIGT38=1;function wrap38(){var im=document.querySelectorAll('img[src*="conoce-mai"]'),i,e,a;for(i=0;i<im.length;i++){e=im[i];if(e.closest('a'))continue;a=document.createElement('a');a.href=(location.pathname.indexOf('/en/')===0?'/en':'')+'/pages/nosotras';a.setAttribute('aria-label','Conoce MAI');a.style.cssText='display:block;cursor:pointer';e.parentNode.insertBefore(a,e);a.appendChild(e);}}setInterval(wrap38,400);})();
/* v39 banner essentials mobile */ (function(){if(window.__MAIGT39)return;window.__MAIGT39=1;var O='essentials-hero-mobile.png',N='essentials-hero-mobile_f37b2477-495a-441a-b80b-171b048952f7.png';function sw39(){var im=document.querySelectorAll('img'),i,s;for(i=0;i<im.length;i++){s=im[i].getAttribute('src')||'';if(s.indexOf(O)>-1)im[i].setAttribute('src',s.replace(O,N));}}void 0;})();
/* v40 imagenes essentials */ (function(){if(window.__MAIGT40)return;window.__MAIGT40=1;var M=[['essentials-hero-mobile.png','essentials-header-mobile.png'],['essentials-header-desktop.png','essentials-header-desktop.png'],['bannermobile.png','essentials-hero-mobile_f37b2477-495a-441a-b80b-171b048952f7.png']];function sw40(){var im=document.querySelectorAll('img'),i,j,s;for(i=0;i<im.length;i++){s=im[i].getAttribute('src')||'';for(j=0;j<M.length;j++){if(s.indexOf(M[j][0])>-1){im[i].setAttribute('src',s.replace(M[j][0],M[j][1]));break;}}}}void 0;})();